import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';
import notify from 'devextreme/ui/notify';

import stringify from '../utils/stableStringify';
import { unpack, pack } from 'msgpackr';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import format from 'string-format';
import AntTime from '../utils/AntTime';
import calculator from '../utils/calculator';
// import $ from 'jquery';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import DataGrid, { Selection, Paging, FilterRow, Scrolling, Grouping } from 'devextreme-react/data-grid';
import Scheduler from 'devextreme-react/scheduler';

import { TextBox, CheckBox, SelectBox, TextArea, NumberBox } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { Tooltip } from 'devextreme-react/tooltip';
import Box, { Item as BoxItem } from 'devextreme-react/box';

import { Template } from 'devextreme-react/core/template';
import cs from '../utils/const';
import AntLocalization from '../utils/AntLocalization';
import AntLocalStorage from '../utils/AntLocalStorage';
import AntProcessingButton from '../components/AntProcessingButton';
import AntPOSSearchGridDataStore from './AntPOSSearchGridDataStore';

import AntConfig from '../utils/AntConfig';
import AntCondition from '../utils/AntCondition';
import AntString from '../utils/AntString';
import AntArray from '../utils/AntArray';
import AntCategory from '../utils/AntCategory';
import AntCardViewSearchBar from './AntPOSCardViewSearchBar';
import AntPOSCategories from './AntPOSCategories';

import { AntGlobal, AntSession } from '../utils/AntContext';
import AntJSON from '../utils/AntJSON';
import { reconcileGridHeaderLayout } from '../utils/AntGridHeaderLayout';

export default forwardRef(function (props, ref) {
    const appGlobal = AntGlobal();
    // const session = AntSession();
    const location = useLocation();
    const navigate = useNavigate();

    if (props.API && !props.API.entityDisplay) {
        if (appGlobal && appGlobal.appConfig && appGlobal.appConfig.Services) {
            let found = appGlobal.appConfig.Services.find((s) => s.name === props.API.entityName);
            if (found) props.API.init({ entityDisplay: found.display });
        }
    }

    const tableName = props.table ? props.table : props.API ? props.API.entityName : '';

    const config = useMemo(() => {
        let found = appGlobal.tableConfigs?.find((t) => t.tableName === tableName);
        if (found) return found.config;

        let cnf = new AntConfig(appGlobal, tableName);
        cnf.configFields(props.fields);

        if (appGlobal.tableConfigs instanceof Array === false) appGlobal.tableConfigs = [];

        appGlobal.tableConfigs.push({
            tableName: tableName,
            config: cnf
        });
        return cnf;
    }, []);

    const compName = props.storageKey
        ? props.storageKey
        : props.name
            ? props.name
            : props.API && props.API.entityName
                ? props.API.entityName
                : props.entityName
                    ? props.entityName
                    : props.url
                        ? props.url
                        : undefined;

    const forceRender = useCallback(() => {
        setShouldRender((v) => v + 1);
    }, []);

    const [shouldRender, setShouldRender] = useState(1);

    const isRender = useMemo(() => shouldRender + (props.shouldRender ? props.shouldRender : 1), [props.shouldRender, shouldRender]);

    const locationPath = location.pathname + '-' + compName;

    const CategoryData = useMemo(() => new AntCategory(appGlobal.appAssets.data.categoryData), []);

    const [formSearchConditions, setFormSearchConditions] = useState({ ...props.searchConditions });

    const loading = useRef(false);
    const loaded = useRef(false);

    const markSelectedField = useRef();
    const grid = useRef();
    const searchBar = useRef();
    const isForeground = useRef(false);
    isForeground.current = props.isForeground !== false;
    const afterActionRefreshTimeout = useRef();
    const autoRefreshTimer = useRef();
    const autoResetUITimer = useRef();

    const [itemsCats1, setItemsCats1] = useState([]);
    const [itemsCats1Loaded, setItemsCats1Loaded] = useState(false);
    const [selectedCats1, setSelectedCats1] = useState([]);

    const selectedCategories = [selectedCats1]
        .flat()
        .map((s) => s.value)
        .flat();

    const dataSource = useRef(
        new AntPOSSearchGridDataStore({
            pageSize: props.pageSize
        })
    );

    const defaultStates = useMemo(() => {
        return {};
    }, []);

    const isAllowNew = useMemo(() => (props.allowNew !== undefined ? props.allowNew : Boolean(props.add || props.showAdd)), [props.allowNew, props.add, props.showAdd]);
    const isRemotePaging = props.remotePaging !== undefined ? props.remotePaging : isAllowNew ? false : true;
    const sortByColumn = useRef(null);
    const sortType = useRef(null);

    const searchParentConditions = useMemo(() => {
        return props.FKField && props.parentData && typeof props.parentData === 'object'
            ? {
                [props.FKField]: props.parentData[props.parentIDField ? props.parentIDField : 'code']
            }
            : {};
    }, [props.FKField, props.parentData, props.parentIDField]);

    const searchConditions = useMemo(() => {
        return {};
    }, []);

    const [finalSearchConditions, setFinalSearchConditions] = useState({});

    const [searchText, setSearchText] = useState('');

    const [focusedRow, setFocusedRow] = useState({ row: null });

    const initGridRowActions = useCallback(() => {
        var actions = [];

        if (props) {
            if (props.showRowActions) {
                let acts = config.getCnfSearchActions(
                    props.rowActionPack ? props.rowActionPack : props.table ? props.table : props.API ? props.API.entityName : null
                );
                actions.push(...acts);
            }

            if (props.rowActions instanceof Array)
                props.rowActions.forEach((item) => {
                    actions.push(item);
                });

            actions = actions.filter((item) => {
                return AntCondition.isVisible(null, item);
            });
        }

        return actions;
    }, [props.showRowActions, props.rowActionPack, props.table, props.API, props.rowActions]);

    const gridRowActions = useMemo(() => initGridRowActions(), [props.showRowActions, props.rowActions, props.rowActionPack]);

    const beginUpdate = useCallback(() => {
        if (grid.current && grid.current.instance) {
            grid.current.instance.beginUpdate();
        }
    }, []);

    const endUpdate = useCallback(() => {
        if (grid.current && grid.current.instance) {
            grid.current.instance.updateDimensions();
            grid.current.instance.endUpdate();
        }
    }, []);

    const dsGetSearchText = useCallback(() => {
        return searchText;
    }, [searchText]);

    const hasRowActions = useCallback(() => {
        if (dataSource.current && dataSource.current.isQuerried()) {
            let acts = dataSource.current
                .getCurrentData()
                .filter((row) => row.actions instanceof Array)
                .map((row) => {
                    row.actions = row.actions.filter((a) => Boolean(a.visible));
                    row.actions = row.actions.filter((a) => gridRowActions.some((rAct) => rAct.code === a.name));
                    return row;
                })
                .filter((row) => row.actions.length > 0);

            return acts.length > 0;
        }
        return false;
    }, [gridRowActions]);

    const isColumnVisible = useCallback(
        (col) => {
            if (col.isSystemCol && col.name === 'actions') {
                return hasRowActions();
            }

            var rawCol = props.columns.find((c) => c.dataField === col.dataField);
            if (rawCol && rawCol.rawConfig) rawCol = rawCol.rawConfig;
            if (!rawCol) return false;

            if (rawCol.visible === true) return true;
            if (rawCol.visible === false) return false;

            var visible = AntCondition.isVisible(props.parentData, rawCol);
            if (
                visible &&
                rawCol.visibleOnMain &&
                props.parentData &&
                Object.keys(props.parentData).length > 0 &&
                (props.parentData.id || props.parentData.code)
            ) {
                let vObj = rawCol.visibleOnMain;
                if (rawCol.visibleOnMain instanceof Array) {
                    vObj = rawCol.visibleOnMain.find(
                        (v) =>
                            v.table === props.parentTable ||
                            (v.table instanceof Array && v.table.includes(props.parentTable)) ||
                            (v.tables instanceof Array && v.tables.includes(props.parentTable))
                    );

                    if (vObj) vObj = vObj.value;
                }
                if (vObj)
                    visible = AntCondition.isVisible(props.parentData, {
                        visible: vObj
                    });
            }

            if (
                visible &&
                col.config &&
                col.config.visibleOnMain &&
                props.parentData &&
                Object.keys(props.parentData).length > 0 &&
                (props.parentData.id || props.parentData.code)
            ) {
                let vObj = col.config.visibleOnMain;
                if (col.config.visibleOnMain instanceof Array) {
                    vObj = col.config.visibleOnMain.find(
                        (v) =>
                            v.table === props.parentTable ||
                            (v.table instanceof Array && v.table.includes(props.parentTable)) ||
                            (v.tables instanceof Array && v.tables.includes(props.parentTable))
                    );

                    if (vObj) vObj = vObj.value;
                }
                if (vObj)
                    visible = AntCondition.isVisible(props.parentData, {
                        visible: vObj
                    });
            }

            if (
                visible &&
                col.config &&
                typeof col.config.visible === 'object' &&
                rawCol.dataType !== 'join' &&
                rawCol.dataType !== 'first' &&
                rawCol.dataType !== 'last'
            ) {
                visible = AntCondition.isVisible(props.parentData, col.config);
            }

            if (visible && rawCol && rawCol.visible && typeof rawCol.visible === 'object' && rawCol.visible.type === 'action') {
                if (rawCol.visible.field) {
                    if (searchConditions.current) {
                        var condKey = Object.keys(searchConditions.current).find((k) => k === rawCol.visible.field);
                        if (condKey && searchConditions.current[condKey] !== undefined)
                            visible = searchConditions.current[condKey] === rawCol.visible.value;
                    }
                }
            }

            if (visible && rawCol.visible !== true && !col.editable && rawCol.hideEmpty !== false && dataSource.current) {
                if (dataSource.current && dataSource.current.getCurrentData().length > 0) {
                    if (rawCol.dataType === 'join') {
                        var fields = rawCol.fields;
                        if (fields instanceof Array) {
                            var isEmptyCol = dataSource.current.isEmptyColumns(fields);
                            visible = !isEmptyCol;
                        }
                    } else {
                        let colField = col.dataField;
                        if (props.showPriority && col.name === 'priority') colField = props.priorityField ? props.priorityField : 'priority';

                        var isEmptyCol = dataSource.current.isEmptyColumn(colField);
                        visible = !isEmptyCol;
                    }
                }
            }

            return visible;
        },
        [props.columns, props.parentData, props.parentTable, props.showPriority, hasRowActions]
    );

    const initColumns = useCallback(() => {
        var columns = [];

        var showIndex = props.showIndex !== undefined ? props.showIndex : true;
        showIndex = showIndex;

        // if (props.showDetail && props.showDetailPosition !== 'right') {
        //     columns.push({
        //         name: 'detail',
        //         label: ' ',
        //         width: 30,
        //         alignment: 'center',
        //         isSystemCol: true,
        //         cellTemplate: 'renderDetailCell',
        //         showInColumnChooser: false
        //     });
        // }

        if (showIndex) {
            columns.push({
                dataField: 'rowIndex',
                name: 'colrowIndex',
                label: '#',
                width: 30,
                alignment: 'center',
                isSystemCol: true,
                showInColumnChooser: false
            });
        }

        if (props.showNote) {
            columns.push({
                name: 'note',
                label: ' ',
                width: 30,
                alignment: 'center',
                isSystemCol: true,
                cellTemplate: 'renderNoteCell',
                showInColumnChooser: false
            });
        }

        if (props.showAttachments) {
            columns.push({
                name: 'attachment',
                label: ' ',
                width: 30,
                isSystemCol: true,
                alignment: 'center',
                cellTemplate: 'renderAttachmentCell',
                showInColumnChooser: false
            });
        }

        if (props.showPriority) {
            var isValid = true;

            if (typeof props.showPriority === 'object' && props.showPriority.when) {
                isValid = AntCondition.isValid(null, {
                    when: props.showPriority.when,
                    whenType: props.showPriority.whenType
                });
            }
            if (isValid)
                columns.push({
                    name: 'priority',
                    label: ' ',
                    width: 30,
                    isSystemCol: true,
                    alignment: 'center',
                    cellTemplate: 'renderPriorityCell',
                    showInColumnChooser: false
                });
        }

        // if (columns.length === 0) {
        //     columns.push({
        //         name: 'seperatorBefore',
        //         label: ' ',
        //         alignment: 'center',
        //         editable: false,
        //         width: 10,
        //         isSystemCol: true,
        //         showInColumnChooser: false
        //     });
        // }

        if (gridRowActions instanceof Array && gridRowActions.length > 0) {
            columns.push({
                name: 'actions',
                label: ' ',
                width: props.rowActionWidth
                    ? props.rowActionWidth
                    : gridRowActions.length <= 1
                        ? 'auto'
                        : gridRowActions.reduce((total, i) => total + ((i.width ? i.width : 60) + 8), 0), //'auto',
                // width: 'auto',
                alignment: 'right',
                isSystemCol: true,
                cellTemplate: 'renderButtonsCell',
                allowHiding: false,
                showInColumnChooser: false
            });
        }

        if (props.columns instanceof Array) {
            props.columns.forEach((col, colIndex) => {
                if (typeof col === 'string') {
                    var dataField = String(col);
                    columns.push({ dataField: dataField, name: 'col_' + dataField });
                } else if (typeof col === 'object' && col.dataField)
                    columns.push({
                        ...JSON.parse(stringify(col)),
                        name: 'col_' + col.dataField,
                        editable: col.editable
                    });
                else if (typeof col === 'object')
                    columns.push({
                        ...JSON.parse(stringify(col)),
                        name: 'col_' + colIndex
                    });
            });
        }

        // if (props.showDetail && props.showDetailPosition === 'right') {
        //     columns.push({
        //         name: 'detail',
        //         label: ' ',
        //         width: 30,
        //         alignment: 'center',
        //         isSystemCol: true,
        //         cellTemplate: 'renderDetailCell',
        //         showInColumnChooser: false
        //     });
        // }

        // columns.push({
        //     name: 'seperatorAfter',
        //     label: ' ',
        //     alignment: 'center',
        //     editable: false,
        //     width: gridRowActions instanceof Array && gridRowActions.length > 0 ? 5 : 6,
        //     isSystemCol: true,
        //     showInColumnChooser: false
        // });

        columns.forEach((col) => {
            // if (col.isSystemCol) return col;

            var rawCol = props.columns.find((f) => f.dataField === col.dataField);
            if (rawCol && rawCol.rawConfig) rawCol = rawCol.rawConfig;

            var colType = !col.isSystemCol && rawCol && rawCol.dataType ? rawCol.dataType : col.dataType;
            var colEditor = rawCol && rawCol.editor ? rawCol.editor : col.editor;
            var colLabel = col.caption ? col.caption : col.label;

            if (colLabel instanceof Array) {
                colLabel = AntCondition.getValue(props.formData, colLabel);
            }

            var colLookupValues =
                rawCol && rawCol.lookup && rawCol.lookup.values instanceof Array
                    ? rawCol.lookup.values
                    : col.lookup && col.lookup.values instanceof Array
                        ? col.lookup.values
                        : null;

            var colWidth = !col.isSystemCol && rawCol && rawCol.width !== undefined ? rawCol.width : col.width;
            var colMinWidth = !col.isSystemCol && rawCol && rawCol.minWidth !== undefined ? rawCol.minWidth : col.minWidth;

            var colAllowHiding = !col.isSystemCol && rawCol && rawCol.allowHiding !== undefined ? rawCol.allowHiding : col.allowHiding;
            var colAlignment = !col.isSystemCol && rawCol && rawCol.alignment !== undefined ? rawCol.alignment : col.alignment;

            var found = null;
            if (config) {
                if (col.dataField || col.cnfField) {
                    var tableName = col.cnfTable ? col.cnfTable : props.table ? props.table : props.API ? props.API.entityName : null;

                    var strField = col.cnfField ? col.cnfField : col.dataField;
                    found = config.getCnfField(strField, tableName);

                    if (found) {
                        if (!colType && found.dataType) colType = found.dataType;
                        if (!colLabel && found.gridLabel) colLabel = found.gridLabel;
                        if (!colLabel && found.label) colLabel = found.label;
                        if (!colLookupValues && found.lookup && found.lookup.values instanceof Array) colLookupValues = found.lookup.values;

                        if (!colWidth && found.width) colWidth = found.width;
                        if (!colMinWidth && found.minWidth) colMinWidth = found.minWidth;
                        if (colAllowHiding === undefined && found.allowHiding !== undefined) colAllowHiding = found.allowHiding;

                        if (!colAlignment) {
                            if (found.dataType === 'currency') colAlignment = 'right';
                            else if (found.dataType === 'float' || found.dataType === 'decimal') colAlignment = 'center';
                            else if (found.dataType === 'int') colAlignment = 'center';
                            else colAlignment = found.alignment;
                        }
                    }

                    if (found && found.cnfTable) {
                        var tableName = found.cnfTable;

                        var strField = found.cnfField ? found.cnfField : col.dataField;
                        found = config.getCnfField(strField, tableName);
                    }

                    if (found) {
                        if (!colType && found.dataType) colType = found.dataType;
                        if (!colLabel && found.gridLabel) colLabel = found.gridLabel;
                        if (!colLabel && found.label) colLabel = found.label;
                        if (!colLookupValues && found.lookup && found.lookup.values instanceof Array) colLookupValues = found.lookup.values;

                        if (!colWidth && found.width) colWidth = found.width;
                        if (!colMinWidth && found.minWidth) colMinWidth = found.minWidth;
                        if (colAllowHiding === undefined && found.allowHiding !== undefined) colAllowHiding = found.allowHiding;

                        if (!colAlignment) {
                            if (found.dataType === 'currency') colAlignment = 'right';
                            else if (found.dataType === 'float' || found.dataType === 'decimal') colAlignment = 'center';
                            else if (found.dataType === 'int') colAlignment = 'center';
                            else colAlignment = found.alignment;
                        }
                        col.config = found;
                    }
                }
            }

            if (colLookupValues instanceof Array)
                colLookupValues = colLookupValues.map((c) => {
                    c.name = AntLocalization.translateText(AntCondition.getValue(props.parentData, c.name));
                    return c;
                });

            col.colType = colType;

            // // if (!colWidth && colType === 'date') colWidth = 76;
            // // if (!colWidth && colType === 'month') colWidth = 70;
            // // if (!colWidth && colType === 'year') colWidth = 70;
            // // if (!colWidth && colType === 'datetime') colWidth = 130;

            // // if (!colWidth && String(col.dataField).endsWith('_status')) colWidth = 100;
            // if (!colWidth && String(col.dataField).endsWith('code')) colWidth = 80;
            // if (!colWidth && String(col.dataField).endsWith('module')) colWidth = 94;
            // if (!colWidth && String(col.dataField).endsWith('type')) colWidth = 94;

            // // if (!colWidth && String(col.dataField).endsWith('item_name')) colWidth = 250;
            // // if (!colWidth && String(col.dataField).endsWith('variant_dimens')) colWidth = 160;
            // // if (!colWidth && String(col.dataField).endsWith('store_name')) colWidth = 130;

            // // if (!colWidth && String(col.dataField).endsWith('entity_name')) colWidth = 200;
            // // if (!colWidth && String(col.dataField).endsWith('warehouse_name')) colWidth = 170;
            // // if (!colWidth && String(col.dataField).endsWith('department')) colWidth = 160;
            // // if (!colWidth && String(col.dataField).endsWith('business_unit')) colWidth = 160;
            // if (!colWidth && String(col.dataField).endsWith('uom')) colWidth = 55;
            // if (!colWidth && String(col.dataField).endsWith('phone')) colWidth = 100;

            // if (String(col.dataField).endsWith('qty')) colWidth = col.isMarkSelected ? 60 : colWidth ? colWidth : 40;

            // if (!colWidth && colType === 'percent') colWidth = 60;

            // // if (!colWidth && String(col.dataField).endsWith('name')) colWidth = 200;

            // if (!colWidth && (colType === 'bool' || colType === 'int') && String(col.dataField).startsWith('is_')) colWidth = 80;

            // // if (colType === 'currency') {
            // //     if (String(col.dataField).endsWith('unit_price')) colWidth = 100;
            // //     else colWidth = 115;
            // // }

            // if (!colWidth || colWidth === 'auto') colWidth = undefined;

            colLabel = AntLocalization.translateText(AntCondition.getValue(props.parentData, colLabel));
            col.caption = String(colLabel).trim();

            var labelWidth = AntString.measureColumnWidth(colLabel);
            if (colLabel) labelWidth += 4;
            if (colType === 'currency') labelWidth += 6;

            if (colLookupValues instanceof Array) {
                var displayField = col.displayField
                    ? col.displayField
                    : found && found.lookup && found.lookup.displayField
                        ? found.lookup.displayField
                        : 'name';

                for (let i = 0; i < colLookupValues.length; i++) {
                    const displayText = colLookupValues[i][displayField];
                    if (displayText) {
                        var displayWidth = AntString.measureCellWidth(displayText);

                        if (labelWidth < displayWidth) labelWidth = displayWidth;
                    }
                }
            }

            // if (colWidth && colWidth !== 'auto' && colLabel && !col.isSystemCol) {
            //     if (colWidth < labelWidth) colWidth = labelWidth;
            // }

            if (!colMinWidth || colMinWidth < labelWidth) colMinWidth = labelWidth;

            // if (!colMinWidth) colMinWidth = colWidth;

            col.width = colWidth;
            col.minWidth = colMinWidth;
            if (String(colLabel).trim().length <= 0) col.minWidth = undefined;
            col.allowHiding = colAllowHiding;
            if (col.allowHiding === undefined) col.allowHiding = true;

            if (!colAlignment) {
                if (String(col.dataField).endsWith('status')) colAlignment = 'center';
                if (String(col.dataField).endsWith('_code')) colAlignment = 'left';
                if (String(col.dataField).endsWith('code')) colAlignment = 'left';
                if (String(col.dataField).endsWith('_qty')) colAlignment = 'center';
                if (String(col.dataField).endsWith('qty')) colAlignment = 'center';
                if (String(col.dataField).endsWith('_pct')) colAlignment = 'center';
                if (String(col.dataField).endsWith('pct')) colAlignment = 'center';
                if (String(col.dataField).endsWith('_amt')) colAlignment = 'right';
                if (String(col.dataField).endsWith('amt')) colAlignment = 'right';
                if (String(col.dataField).endsWith('_price')) colAlignment = 'right';
                if (String(col.dataField).endsWith('price')) colAlignment = 'right';
            }
            // if (!colAlignment) colAlignment = 'left';
            col.alignment = colAlignment;

            if (sortByColumn.current) {
                if (sortByColumn.current === col.dataField) {
                    col.sortIndex = 0;
                    sortType.current = sortType.current ? sortType.current : 'asc';
                    col.sortOrder = sortType.current;
                }
            } else if (col.defaultSort) {
                sortByColumn.current = col.dataField;
                col.sortIndex = 0;
                sortType.current = col.defaultSort.order ? col.defaultSort.order : 'asc';
                col.sortOrder = sortType.current;
            }

            if (colLookupValues instanceof Array) {
                col.calculateCellValue = (data) => {
                    if (data) {
                        var colValue = data[col.dataField];
                        var valueField = col.valueField
                            ? col.valueField
                            : found && found.lookup && found.lookup.valueField
                                ? found.lookup.valueField
                                : 'code';
                        var displayField = col.displayField
                            ? col.displayField
                            : found && found.lookup && found.lookup.displayField
                                ? found.lookup.displayField
                                : 'name';
                        if (colValue != null) {
                            var obj = colLookupValues.find((f) => f[valueField] === colValue);
                            if (obj) return obj[displayField];
                        }
                        return colValue;
                    }
                    return null;
                };

                col.calculateDisplayValue = (data) => {
                    if (data) {
                        var colValue = data[col.dataField];
                        var valueField = col.valueField
                            ? col.valueField
                            : found && found.lookup && found.lookup.valueField
                                ? found.lookup.valueField
                                : 'code';
                        var displayField = col.displayField
                            ? col.displayField
                            : found && found.lookup && found.lookup.displayField
                                ? found.lookup.displayField
                                : 'name';
                        if (colValue != null) {
                            var obj = colLookupValues.find((f) => f[valueField] === colValue);
                            if (obj) colValue = obj[displayField];
                        }

                        if (col.customDisplay) colValue = col.customDisplay(data);
                        else if (col.config && col.config.customDisplay) colValue = col.config.customDisplay(data);

                        if (typeof colValue === 'string') colValue = String(colValue);
                        if (colValue === AntLocalization.translateText({ vi: 'Không', en: 'None', fr: 'Aucun', es: 'Ninguno', id: 'Tidak ada', ja: 'なし', zh: '无', ko: '없음', hi: 'कोई नहीं', ar: 'لا شيء' }) && col.displayNoneAsEmpty !== false)
                            colValue = '';
                        if (colValue === null || colValue === undefined) colValue = '';

                        return colValue;
                    }
                    return '';
                };
            } else {
                if (colType === 'bool' || colEditor == 'CheckBox') {
                    // if (!col.alignment)
                    col.alignment = 'center';

                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        if (data) {
                            if (typeof data[col.dataField] == 'boolean') return data[col.dataField];
                            if (typeof data[col.dataField] == 'string') return String(data[col.dataField]).trim() !== '';

                            if (typeof data[col.dataField] == 'number') return data[col.dataField] != 0;

                            // if (data[col.dataField] === 1) return true;

                            if (colType === 'bool') return parseInt(data[col.dataField]) === 1;
                            if (colType === 'int') return parseInt(data[col.dataField]) > 0;
                            if (colType === 'float') return parseFloat(data[col.dataField]) > 0;
                            else return parseFloat(data[col.dataField]) > 0;
                        }
                        return false;
                    };
                    col.cellTemplate = 'renderCheckboxCell';
                    col.dataType = 'boolean';
                }

                if (colType === 'int') {
                    if (!col.format) {
                        // col.format = '#,##0';
                        col.format = (value) => {
                            return AntLocalization.translateInteger(
                                value,
                                col.showSign !== undefined
                                    ? col.showSign
                                    : col.config && col.config.showSign !== undefined
                                        ? col.config.showSign
                                        : false
                            );
                        };
                    }

                    // if (!col.format) col.format = { type: 'fixedPoint' };
                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseInt(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseInt(value);
                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'number';
                }

                if (colType === 'float' || colType === 'decimal') {
                    if (!col.format) {
                        var decimalDigit = found && found.decimalDigit !== undefined && found.decimalDigit !== null ? found.decimalDigit : undefined;
                        if (decimalDigit === undefined || decimalDigit === null) decimalDigit = AntLocalization.getCurrencyDecimalDigit();
                        if (decimalDigit === undefined || decimalDigit === null) decimalDigit = 2;

                        var strFormat = decimalDigit > 0 ? '#,##0.' + String('#').repeat(decimalDigit) : '#,##0';
                        if (col.unitType === 'Km') strFormat = strFormat + ' Km';

                        col.format = strFormat;
                    }

                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        else if (value === null || value === undefined) value = '';
                        else {
                            let showSign = Boolean(col.showSign || (col.config && col.config.showSign && col.showSign !== false));
                            value = AntLocalization.translateDecimal(value, showSign);
                        }
                        return value;
                    };
                    col.dataType = 'number';
                }

                if (colType === 'day') {
                    if (!col.format) {
                        var language = AntLocalStorage.getBusinessSetting('Sys_BaseLanguage');
                        var lblValue = language === 'vi-VN' ? 'ngày' : 'day';
                        col.format = '#,##0 ' + lblValue;
                    }
                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'number';
                }

                if (colType === 'month') {
                    if (!col.alignment) col.alignment = 'center';
                    col.calculateDisplayValue = (data) => {
                        if (data && data[col.dataField] != null) {
                            var value = parseFloat(data[col.dataField]);
                            if (value) {
                                if (String(value).length > 6) {
                                    return AntTime.fromUnix(value).format('MM/YYYY');
                                } else return AntTime.fromString(format('{0}-{1}-01 00:01', Math.floor(value / 100), value % 100)).format('MM/YYYY');
                            }
                        } else return '';
                    };
                    col.dataType = 'number';
                }

                if (col.config && col.config.dataTypeDisplay === 'month') {
                    if (!col.format) {
                        var lblValue = AntLocalization.translateText({ vi: 'Tháng', en: 'Month', fr: 'Mois', es: 'Mes', id: 'Bulan', ja: '月', zh: '月', ko: '월', hi: 'महीना', ar: 'شهر' });
                        col.format = '#,##0 ' + lblValue;
                    }

                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'number';
                }

                if (colType === 'year') {
                    if (!col.alignment) col.alignment = 'center';
                    col.calculateDisplayValue = (data) => {
                        if (data && data[col.dataField] != null) {
                            var value = parseFloat(data[col.dataField]);
                            if (value) {
                                if (String(value).length > 6) {
                                    return AntTime.fromUnix(value).format('YYYY');
                                } else return AntTime.fromString(format('{0}-01-01 00:01', parseInt(value))).format('YYYY');
                            }
                        } else return '';
                    };
                    col.dataType = 'number';
                }

                if (col.config && col.config.dataTypeDisplay === 'year') {
                    if (!col.format) {
                        var language = AntLocalStorage.getBusinessSetting('Sys_BaseLanguage');
                        var lblValue = language === 'vi-VN' ? AntLocalization.translateText({ vi: 'Năm', en: 'Year', fr: 'Année', es: 'Año', id: 'Tahun', ja: '年', zh: '年', ko: '년', hi: 'वर्ष', ar: 'سنة' }) : 'year';
                        col.format = '#,##0 ' + lblValue;
                    }

                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'number';
                }

                if (colType === 'period') {
                    if (!col.format) {
                        var lblValue = AntLocalization.translateText({ vi: 'kỳ', en: 'period', fr: 'période', es: 'período', id: 'periode', ja: '期間', zh: '期', ko: '기간', hi: 'अवधि', ar: 'فترة' });

                        col.format = '#,##0 ' + lblValue;
                    }
                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'number';
                }

                if (colType === 'percent') {
                    if (!col.format) {
                        var decimalDigit = found && found.decimalDigit !== undefined && found.decimalDigit !== null ? found.decimalDigit : undefined;
                        // if (decimalDigit === undefined || decimalDigit === null)
                        //     decimalDigit = AntLocalization.getCurrencyDecimalDigit();
                        if (decimalDigit === undefined || decimalDigit === null) decimalDigit = 0;
                        col.format = {
                            type: 'percent',
                            precision: decimalDigit
                        };
                    }

                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'number';
                }

                if (colType === 'currency') {
                    // if (!col.format) {
                    //     // var currency = AntLocalStorage.getSetting('Sys_BaseCurrency');
                    //     // var lblValue = currency === 'VND' ? 'đ' : '$';
                    //     // col.format = currency === 'VND' ? '#,##0 ' + lblValue : lblValue + ' #,##0';

                    //     col.format = (value) => {
                    //         let fValue= AntLocalization.translateCurrency(
                    //             value,
                    //             col.showSign !== undefined
                    //                 ? col.showSign
                    //                 : col.config && col.config.showSign !== undefined
                    //                 ? col.config.showSign
                    //                 : false
                    //         );
                    //         return fValue;
                    //     };
                    // }

                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;

                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        else if (value === null || value === undefined) value = '';
                        else if (value > 0 && (col.showSign || (col.config && col.config.showSign && col.showSign !== false))) {
                            value = AntLocalization.translateCurrency(value, true);
                        } else value = AntLocalization.translateCurrency(value);

                        return value;
                    };

                    col.dataType = 'number';
                }

                if (colType === 'date') {
                    if (!col.alignment) col.alignment = 'center';
                    if (!col.format)
                        col.format = function (value) {
                            if (!value) return '';

                            if (AntTime.isUnixWithinToDay(value)) {
                                if (col.showTimeWithinToday) return AntTime.fromUnix(value).format('HH:mm');
                                else
                                    return AntLocalization.translateText({ vi: 'Hôm nay', en: 'Today', fr: 'Aujourd\'hui', es: 'Hoy', id: 'Hari ini', ja: '今日', zh: '今天', ko: '오늘', hi: 'आज', ar: 'اليوم' });
                            }

                            if (AntTime.isUnixWithinYesterday(value))
                                return AntLocalization.translateText({ vi: 'Hôm qua', en: 'Yesterday', fr: 'Hier', es: 'Ayer', id: 'Kemarin', ja: '昨日', zh: '昨天', ko: '어제', hi: 'कल (बीता)', ar: 'أمس' });

                            if (AntTime.isUnixWithinTomorrow(value))
                                return AntLocalization.translateText({ vi: 'Ngày mai', en: 'Tomorrow', fr: 'Demain', es: 'Mañana', id: 'Besok', ja: '明日', zh: '明天', ko: '내일', hi: 'कल (आने वाला)', ar: 'غداً' });

                            if (AntTime.isUnixWithinCurrentYear(value)) return AntTime.fromUnix(value).format('DD/MM');

                            // if (col.showTimeWithinToday) return AntTime.fromUnix(value).format('DD/MM');

                            return AntTime.fromUnix(value).format('DD/MM/YY');
                        };
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (col.customDisplay) value = col.customDisplay(data);
                        else if (col.config && col.config.customDisplay) value = col.config.customDisplay(data);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'date';
                }

                if (colType === 'datetime') {
                    if (!col.alignment) col.alignment = 'center';
                    if (!col.format)
                        col.format = function (value) {
                            if (!value) return '';

                            if (AntTime.isUnixWithinToDay(value)) return AntTime.fromUnix(value).format('HH:mm');

                            if (AntTime.isUnixWithinCurrentYear(value)) return AntTime.fromUnix(value).format('DD/MM HH:mm');

                            return AntTime.fromUnix(value).format('DD/MM/YY');
                        };
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };

                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (col.customDisplay) value = col.customDisplay(data);
                        else if (col.config && col.config.customDisplay) value = col.config.customDisplay(data);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'date';
                }

                if (colType === 'time') {
                    if (!col.alignment) col.alignment = 'center';
                    if (!col.format) col.format = 'hh:mm a';

                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };

                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = AntTime.fromUnix(parseFloat(value)).toDate();

                        if (col.customDisplay) value = col.customDisplay(data);
                        else if (col.config && col.config.customDisplay) value = col.config.customDisplay(data);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'date';
                }

                if (colType === 'weekday') {
                    if (!col.alignment) col.alignment = 'left';
                    if (!col.format)
                        col.format = function (value) {
                            if (!value) return '';

                            const dayOfWeek = parseInt(AntTime.fromUnix(value).isoWeekday());
                            if (dayOfWeek === 1) return AntLocalization.translateText({ vi: 'Thứ Hai', en: 'Monday', fr: 'Lundi', es: 'Lunes', id: 'Senin', ja: '月曜日', zh: '星期一', ko: '월요일', hi: 'सोमवार', ar: 'الإثنين' });
                            if (dayOfWeek === 2) return AntLocalization.translateText({ vi: 'Thứ Ba', en: 'Tuesday', fr: 'Mardi', es: 'Martes', id: 'Selasa', ja: '火曜日', zh: '星期二', ko: '화요일', hi: 'मंगलवार', ar: 'الثلاثاء' });
                            if (dayOfWeek === 3) return AntLocalization.translateText({ vi: 'Thứ Tư', en: 'Wednesday', fr: 'Mercredi', es: 'Miércoles', id: 'Rabu', ja: '水曜日', zh: '星期三', ko: '수요일', hi: 'बुधवार', ar: 'الأربعاء' });
                            if (dayOfWeek === 4) return AntLocalization.translateText({ vi: 'Thứ Năm', en: 'Thursday', fr: 'Jeudi', es: 'Jueves', id: 'Kamis', ja: '木曜日', zh: '星期四', ko: '목요일', hi: 'गुरुवार', ar: 'الخميس' });
                            if (dayOfWeek === 5) return AntLocalization.translateText({ vi: 'Thứ Sáu', en: 'Friday', fr: 'Vendredi', es: 'Viernes', id: 'Jumat', ja: '金曜日', zh: '星期五', ko: '금요일', hi: 'शुक्रवार', ar: 'الجمعة' });
                            if (dayOfWeek === 6) return AntLocalization.translateText({ vi: 'Thứ Bảy', en: 'Saturday', fr: 'Samedi', es: 'Sábado', id: 'Sabtu', ja: '土曜日', zh: '星期六', ko: '토요일', hi: 'शनिवार', ar: 'السبت' });
                            if (dayOfWeek === 7) return AntLocalization.translateText({ vi: 'Chủ Nhật', en: 'Sunday', fr: 'Dimanche', es: 'Domingo', id: 'Minggu', ja: '日曜日', zh: '星期日', ko: '일요일', hi: 'रविवार', ar: 'الأحد' });

                            return AntTime.fromUnix(value).format('DD/MM/YY');
                        };

                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value === null || value === undefined) return value;
                        if (typeof value === 'number') return parseFloat(value);

                        return value;
                    };
                    col.calculateDisplayValue = (data) => {
                        var value = data ? data[col.dataField] : null;
                        if (typeof value === 'number') value = parseFloat(value);

                        if (col.customDisplay) value = col.customDisplay(data);
                        else if (col.config && col.config.customDisplay) value = col.config.customDisplay(data);

                        if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                        if (value === null || value === undefined) value = '';

                        return value;
                    };
                    col.dataType = 'date';
                }

                if (colType === 'duration') {
                    if (!col.alignment) col.alignment = 'right';
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);
                        var value = data ? data[col.startField] : null;
                        if (!value) return '';

                        var minutes = AntTime.diffMinuteToNow(value, true);
                        minutes = Math.ceil(minutes);

                        var vDays = Math.floor(Math.abs(minutes) / (60 * 24));
                        var vHours = Math.floor(Math.abs(minutes) / 60) - vDays * 24;
                        var vMinutes = Math.abs(minutes) - Math.floor(Math.abs(minutes) / 60) * 60;

                        // if (!vDays && !vHours && vMinutes)
                        //     return [vMinutes ? format('{0} phút', vMinutes) : null].filter((v) => Boolean(v)).join(' ');

                        // if (!vDays && vHours && !vMinutes) return [vHours ? format('{0} giờ', vHours) : null].filter((v) => Boolean(v)).join(' ');

                        // if (!vDays)
                        //     return [vHours ? format('{0}g', vHours) : null, vMinutes ? format('{0}ph', vMinutes) : null]
                        //         .filter((v) => Boolean(v))
                        //         .join(' ');

                        // value = [
                        //     vDays ? format('{0}ng', vDays) : null,
                        //     vHours ? format('{0}g', vHours) : null,
                        //     vMinutes ? format('{0}ph', vMinutes) : null
                        // ]
                        //     .filter((v) => Boolean(v))
                        //     .join(' ');

                        // value = [
                        //     vDays ? format('{0} ngày', vDays) : null,
                        //     vHours ? format('{0} giờ', vHours) : null,
                        //     vMinutes ? format('{0} phút', vMinutes) : null
                        // ]

                        if (vDays)
                            value = [
                                vDays
                                    ? format('{0} {1}', vDays, AntLocalization.translateText({ vi: 'ngày', en: vDays > 1 ? 'days' : 'day', fr: vDays > 1 ? 'jours' : 'jour', es: vDays > 1 ? 'días' : 'día', id: 'hari', ja: '日', zh: '天', ko: '일', hi: 'दिन', ar: vDays > 1 ? 'أيام' : 'يوم' }))
                                    : null,
                                vHours
                                    ? format('{0} {1}', vHours, AntLocalization.translateText({ vi: 'giờ', en: vHours > 1 ? 'hours' : 'hour', fr: vHours > 1 ? 'heures' : 'heure', es: vHours > 1 ? 'horas' : 'hora', id: 'jam', ja: '時間', zh: '小时', ko: '시간', hi: 'घंटे', ar: vHours > 1 ? 'ساعات' : 'ساعة' }))
                                    : null
                            ];
                        else if (vHours)
                            value = [
                                vHours
                                    ? format('{0} {1}', vHours, AntLocalization.translateText({ vi: 'giờ', en: vHours > 1 ? 'hours' : 'hour', fr: vHours > 1 ? 'heures' : 'heure', es: vHours > 1 ? 'horas' : 'hora', id: 'jam', ja: '時間', zh: '小时', ko: '시간', hi: 'घंटे', ar: vHours > 1 ? 'ساعات' : 'ساعة' }))
                                    : null,
                                vMinutes
                                    ? format(
                                        '{0} {1}',
                                        vMinutes,
                                        AntLocalization.translateText({ vi: 'phút', en: vMinutes > 1 ? 'minutes' : 'minute', fr: vMinutes > 1 ? 'minutes' : 'minute', es: vMinutes > 1 ? 'minutos' : 'minuto', id: 'menit', ja: '分', zh: '分钟', ko: '분', hi: 'मिनट', ar: vMinutes > 1 ? 'دقائق' : 'دقيقة' })
                                    )
                                    : null
                            ];
                        else
                            value = [
                                vMinutes
                                    ? format(
                                        '{0} {1}',
                                        vMinutes,
                                        AntLocalization.translateText({ vi: 'phút', en: vMinutes > 1 ? 'minutes' : 'minute', fr: vMinutes > 1 ? 'minutes' : 'minute', es: vMinutes > 1 ? 'minutos' : 'minuto', id: 'menit', ja: '分', zh: '分钟', ko: '분', hi: 'मिनट', ar: vMinutes > 1 ? 'دقائق' : 'دقيقة' })
                                    )
                                    : null
                            ];

                        value = value.filter((v) => Boolean(v)).join(' ');
                        if (minutes < 0) value = format('{1} {0}', value, AntLocalization.translateText({ vi: 'Còn', en: 'Remain', fr: 'Reste', es: 'Quedan', id: 'Sisa', ja: '残り', zh: '剩余', ko: '남은', hi: 'शेष', ar: 'متبقي' }));
                        return value;
                    };

                    col.dataType = 'string';
                }

                if (colType === 'join') {
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);
                        var fields = col.fields;
                        if (fields instanceof Array) {
                            var tableName = col.cnfTable ? col.cnfTable : props.table ? props.table : props.API ? props.API.entityName : null;

                            var ar = [];

                            for (let i = 0; i < fields.length; i++) {
                                const fField = fields[i];

                                let fFieldName = fField;
                                if (fField && typeof fField === 'object' && fField.dataField) fFieldName = fField.dataField;

                                if (!(fField && typeof fField === 'object' && fField.visible === true)) {
                                    var found = config.getCnfField(fField, tableName);
                                    if (found && found.cnfTable)
                                        found = config.getCnfField(found.cnfField, found.cnfTable ? found.cnfTable : tableName);

                                    if (found) {
                                        var visible = AntCondition.isVisible(props.parentData, found);
                                        if (
                                            visible &&
                                            found.visibleOnMain &&
                                            props.parentData &&
                                            Object.keys(props.parentData).length > 0 &&
                                            (props.parentData.id || props.parentData.code)
                                        ) {
                                            let vObj = found.visibleOnMain;
                                            if (found.visibleOnMain instanceof Array) {
                                                vObj = found.visibleOnMain.find(
                                                    (v) =>
                                                        v.table === props.parentTable ||
                                                        (v.table instanceof Array && v.table.includes(props.parentTable)) ||
                                                        (v.tables instanceof Array && v.tables.includes(props.parentTable))
                                                );

                                                if (vObj) vObj = vObj.value;
                                            }
                                            if (vObj)
                                                visible = AntCondition.isVisible(props.parentData, {
                                                    visible: vObj
                                                });
                                        }
                                        if (!visible) continue;
                                    }
                                }

                                var valueField = found && found.lookup && found.lookup.valueField ? found.lookup.valueField : 'code';
                                var displayField = found && found.lookup && found.lookup.displayField ? found.lookup.displayField : 'name';
                                var lookupValues = found && found.lookup && found.lookup.values instanceof Array ? found.lookup.values : [];

                                var fValue = data[fFieldName];
                                if (fValue != null) {
                                    var obj = lookupValues.find((f) => f[valueField] === fValue);
                                    if (obj) fValue = obj[displayField];
                                }

                                if (fValue instanceof Array) {
                                    for (let j = 0; j < fValue.length; j++) {
                                        let jValue = fValue[j];

                                        jValue = AntLocalization.translateText(jValue);

                                        if (typeof jValue === 'string') jValue = String(jValue);
                                        if (jValue === null || jValue === undefined) jValue = '';
                                        ar.push(jValue);
                                    }
                                } else {
                                    fValue = AntLocalization.translateText(fValue);

                                    if (typeof fValue === 'string') fValue = String(fValue);
                                    if (fValue === AntLocalization.translateText({ vi: 'Không', en: 'None', fr: 'Aucun', es: 'Ninguno', id: 'Tidak ada', ja: 'なし', zh: '无', ko: '없음', hi: 'कोई नहीं', ar: 'لا شيء' }) && col.displayNoneAsEmpty !== false)
                                        fValue = '';
                                    if (fValue === null || fValue === undefined) fValue = '';

                                    if (fValue && parseInt(fValue) && String(fFieldName).endsWith('_adm2_name'))
                                        fValue = AntLocalization.translateText({ vi: 'Quận', en: 'Dist', fr: 'District', es: 'Distrito', id: 'Distrik', ja: '地区', zh: '区', ko: '구역', hi: 'जिला', ar: 'منطقة' }) + ' ' + fValue;

                                    ar.push(fValue);
                                }
                            }

                            ar = AntArray.distinct(
                                ar
                                    .flat()
                                    .filter((f) => Boolean(f))
                                    .map((f) => String(f))
                            );

                            return ar.join(col.separator ? col.separator : ', ');
                        }

                        return '';
                    };
                    col.dataType = 'string';
                }

                if (colType === 'first') {
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);
                        var fields = col.fields;
                        if (fields instanceof Array) {
                            var tableName = col.cnfTable ? col.cnfTable : props.table ? props.table : props.API ? props.API.entityName : null;

                            var ar = [];

                            for (let i = 0; i < fields.length; i++) {
                                const fField = fields[i];

                                let fFieldName = fField;
                                if (fField && typeof fField === 'object' && fField.dataField) fFieldName = fField.dataField;

                                if (!(fField && typeof fField === 'object' && fField.visible === true)) {
                                    var found = config.getCnfField(fField, tableName);
                                    if (found && found.cnfTable)
                                        found = config.getCnfField(found.cnfField, found.cnfTable ? found.cnfTable : tableName);

                                    if (found) {
                                        var visible = AntCondition.isVisible(props.parentData, found);
                                        if (
                                            visible &&
                                            found.visibleOnMain &&
                                            props.parentData &&
                                            Object.keys(props.parentData).length > 0 &&
                                            (props.parentData.id || props.parentData.code)
                                        ) {
                                            let vObj = found.visibleOnMain;
                                            if (found.visibleOnMain instanceof Array) {
                                                vObj = found.visibleOnMain.find(
                                                    (v) =>
                                                        v.table === props.parentTable ||
                                                        (v.table instanceof Array && v.table.includes(props.parentTable)) ||
                                                        (v.tables instanceof Array && v.tables.includes(props.parentTable))
                                                );

                                                if (vObj) vObj = vObj.value;
                                            }
                                            if (vObj)
                                                visible = AntCondition.isVisible(props.parentData, {
                                                    visible: vObj
                                                });
                                        }
                                        if (!visible) continue;
                                    }
                                }

                                var valueField = found && found.lookup && found.lookup.valueField ? found.lookup.valueField : 'code';
                                var displayField = found && found.lookup && found.lookup.displayField ? found.lookup.displayField : 'name';
                                var lookupValues = found && found.lookup && found.lookup.values instanceof Array ? found.lookup.values : [];

                                var fValue = data[fFieldName];
                                if (fValue != null) {
                                    var obj = lookupValues.find((f) => f[valueField] === fValue);
                                    if (obj) fValue = obj[displayField];
                                }

                                if (fValue instanceof Array) {
                                    for (let j = 0; j < fValue.length; j++) {
                                        let jValue = fValue[j];

                                        jValue = AntLocalization.translateText(jValue);

                                        if (typeof jValue === 'string') jValue = String(jValue);
                                        if (jValue === null || jValue === undefined) jValue = '';
                                        ar.push(jValue);
                                    }
                                } else {
                                    fValue = AntLocalization.translateText(fValue);

                                    if (typeof fValue === 'string') fValue = String(fValue);
                                    if (fValue === AntLocalization.translateText({ vi: 'Không', en: 'None', fr: 'Aucun', es: 'Ninguno', id: 'Tidak ada', ja: 'なし', zh: '无', ko: '없음', hi: 'कोई नहीं', ar: 'لا شيء' }) && col.displayNoneAsEmpty !== false)
                                        fValue = '';
                                    if (fValue === null || fValue === undefined) fValue = '';

                                    if (fValue && parseInt(fValue) && String(fFieldName).endsWith('_adm2_name'))
                                        fValue = AntLocalization.translateText({ vi: 'Quận', en: 'Dist', fr: 'District', es: 'Distrito', id: 'Distrik', ja: '地区', zh: '区', ko: '구역', hi: 'जिला', ar: 'منطقة' }) + ' ' + fValue;

                                    ar.push(fValue);
                                }
                            }
                            return ar
                                .filter((f) => Boolean(f))
                                .map((f) => String(f))
                                .shift();
                        }

                        return '';
                    };
                    col.dataType = 'string';
                }

                if (colType === 'last') {
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);
                        var fields = col.fields;
                        if (fields instanceof Array) {
                            var tableName = col.cnfTable ? col.cnfTable : props.table ? props.table : props.API ? props.API.entityName : null;

                            var ar = [];

                            for (let i = 0; i < fields.length; i++) {
                                const fField = fields[i];

                                let fFieldName = fField;
                                if (fField && typeof fField === 'object' && fField.dataField) fFieldName = fField.dataField;

                                if (!(fField && typeof fField === 'object' && fField.visible === true)) {
                                    var found = config.getCnfField(fField, tableName);
                                    if (found && found.cnfTable)
                                        found = config.getCnfField(found.cnfField, found.cnfTable ? found.cnfTable : tableName);

                                    if (found) {
                                        var visible = AntCondition.isVisible(props.parentData, found);
                                        if (
                                            visible &&
                                            found.visibleOnMain &&
                                            props.parentData &&
                                            Object.keys(props.parentData).length > 0 &&
                                            (props.parentData.id || props.parentData.code)
                                        ) {
                                            let vObj = found.visibleOnMain;
                                            if (found.visibleOnMain instanceof Array) {
                                                vObj = found.visibleOnMain.find(
                                                    (v) =>
                                                        v.table === props.parentTable ||
                                                        (v.table instanceof Array && v.table.includes(props.parentTable)) ||
                                                        (v.tables instanceof Array && v.tables.includes(props.parentTable))
                                                );

                                                if (vObj) vObj = vObj.value;
                                            }
                                            if (vObj)
                                                visible = AntCondition.isVisible(props.parentData, {
                                                    visible: vObj
                                                });
                                        }
                                        if (!visible) continue;
                                    }
                                }

                                var valueField = found && found.lookup && found.lookup.valueField ? found.lookup.valueField : 'code';
                                var displayField = found && found.lookup && found.lookup.displayField ? found.lookup.displayField : 'name';
                                var lookupValues = found && found.lookup && found.lookup.values instanceof Array ? found.lookup.values : [];

                                var fValue = data[fFieldName];
                                if (fValue != null) {
                                    var obj = lookupValues.find((f) => f[valueField] === fValue);
                                    if (obj) fValue = obj[displayField];
                                }

                                if (fValue instanceof Array) {
                                    for (let j = 0; j < fValue.length; j++) {
                                        let jValue = fValue[j];

                                        jValue = AntLocalization.translateText(jValue);

                                        if (typeof jValue === 'string') jValue = String(jValue);
                                        if (jValue === null || jValue === undefined) jValue = '';
                                        ar.push(jValue);
                                    }
                                } else {
                                    fValue = AntLocalization.translateText(fValue);

                                    if (typeof fValue === 'string') fValue = String(fValue);
                                    if (fValue === AntLocalization.translateText({ vi: 'Không', en: 'None', fr: 'Aucun', es: 'Ninguno', id: 'Tidak ada', ja: 'なし', zh: '无', ko: '없음', hi: 'कोई नहीं', ar: 'لا شيء' }) && col.displayNoneAsEmpty !== false)
                                        fValue = '';
                                    if (fValue === null || fValue === undefined) fValue = '';

                                    if (fValue && parseInt(fValue) && String(fFieldName).endsWith('_adm2_name'))
                                        fValue = AntLocalization.translateText({ vi: 'Quận', en: 'Dist', fr: 'District', es: 'Distrito', id: 'Distrik', ja: '地区', zh: '区', ko: '구역', hi: 'जिला', ar: 'منطقة' }) + ' ' + fValue;

                                    ar.push(fValue);
                                }
                            }
                            return ar
                                .filter((f) => Boolean(f))
                                .map((f) => String(f))
                                .pop();
                        }

                        return '';
                    };
                    col.dataType = 'string';
                }

                if (colType === 'string') {
                    col.calculateCellValue = (data) => {
                        if (col.customCellValue) return col.customCellValue(data);

                        var value = data ? data[col.dataField] : null;
                        if (value && value instanceof Array) value = value.map((f) => String(f)).join(col.separator ? col.separator : ', ');

                        if (col.upper) value = String(value).toUpperCase();

                        return value;
                    };
                    col.dataType = 'string';
                }

                // if (col.autoShortten)
                // if (col.dataField === 'entity_name') col.cellTemplate = 'renderContentCell';
            }
            // if (col.link) col.cellTemplate = 'renderLinkCell';
            if (col.boldable) col.cellTemplate = 'renderBoldCell';
            if (col.customFormatable) col.cellTemplate = 'renderCustomFormatCell';

            // if (props.allowEdit || Boolean(col.editable)) {

            var editable = col.editable !== undefined ? Boolean(col.editable) : false;
            if (typeof col.editable === 'object') {
                if (col.editable.type === 'action' && col.editable.field) {
                    editable = false;
                    var condKey = Object.keys(searchConditions.current).find((k) => k === col.editable.field);
                    if (condKey && searchConditions.current[condKey] !== undefined)
                        editable = searchConditions.current[condKey] === col.editable.value;
                } else if (props.parentData) {
                    editable = AntCondition.isEditable(props.parentData, col);
                }
            }

            col.allowEditing = Boolean(editable);
            if (col.allowEditing) col.cssClass = 'ant-grid-col-editable';

            col.editorOptions = {
                ...props.editorOptions
            };
            // if (col.allowEditing) {
            if (colType === 'currency') {
                var currency = AntLocalStorage.getSetting('Sys_BaseCurrency');
                var lblValue = currency === 'VND' ? 'đ' : '$';

                col.editorOptions.format = currency === 'VND' ? '#,##0 ' + lblValue : lblValue + ' #,##0';
            }

            if (colType === 'int' || colType === 'fixedPoint') col.editorOptions.format = '#,##0';

            if (colType === 'float' || colType === 'decimal') {
                var decimalDigit = found ? found.decimalDigit : undefined;
                if (decimalDigit === undefined || decimalDigit === null) decimalDigit = AntLocalization.getCurrencyDecimalDigit();

                if (decimalDigit === undefined || decimalDigit === null) decimalDigit = 2;
                col.editorOptions.format = '#,##0.' + String('#').repeat(decimalDigit);
            }

            if (colType === 'percent') {
                var decimalDigit = found ? found.decimalDigit : undefined;
                // if (decimalDigit === undefined || decimalDigit === null) decimalDigit = AntLocalization.getCurrencyDecimalDigit();
                if (decimalDigit === undefined || decimalDigit === null) decimalDigit = 0;
                col.editorOptions.format = {
                    type: 'percent',
                    precision: decimalDigit
                };
            }

            // }
            // col.editCellTemplate = 'renderCellEditor';
            // }
        });

        // columns.forEach((col) => {
        //     if (col.hidingPriority !== undefined) col.hidingPriority = parseInt(col.hidingPriority) * 100;
        // });

        var minHidingPriority = Number.MAX_SAFE_INTEGER;
        columns.forEach((col) => {
            if (!col.isSystemCol && col.hidingPriority !== undefined && col.hidingPriority < minHidingPriority)
                minHidingPriority = col.hidingPriority;
        });

        var ar = [];

        columns.forEach((col) => {
            if (!col.isSystemCol && col.hidingPriority === undefined) ar.push(col);
        });

        for (let i = 0; i < ar.length; i++) {
            var col1 = ar[i];
            var col2 = ar[ar.length - i - 1];
            if (col1.hidingPriority === undefined) {
                minHidingPriority--;
                col1.hidingPriority = minHidingPriority;
            }
            if (col2.hidingPriority === undefined) {
                minHidingPriority--;
                col2.hidingPriority = minHidingPriority;
            }
        }

        minHidingPriority = Number.MAX_SAFE_INTEGER;
        columns.forEach((col) => {
            if (!col.isSystemCol && col.hidingPriority !== undefined && col.hidingPriority < minHidingPriority)
                minHidingPriority = col.hidingPriority;
        });

        columns.forEach((col) => {
            if (!col.isSystemCol && col.hidingPriority !== undefined) col.hidingPriority = col.hidingPriority - minHidingPriority;
        });

        if (props.columns instanceof Array) {
            props.columns.forEach((rawCol) => {
                var col = columns.find((c) => c.name === 'col_' + rawCol.dataField);
                if (col) {
                    col.visible = isColumnVisible(col);
                }
            });

            var count = columns.filter((c) => !c.isSystemCol && Boolean(c.visible) && c.width === 'auto').length;
            if (count <= 0) {
                props.columns.forEach((rawCol) => {
                    var col = columns.find((c) => c.name === 'col_' + rawCol.dataField);
                    if (col && col.width === 'auto') {
                        col.visible = isColumnVisible(col);
                    }
                });
            }
        }

        // var isOK = columns.some((c) => !c.isSystemCol && c.visible && c.width === 'auto');
        // if (!isOK) {
        //     var col = columns.find(
        //         (c) => !c.isSystemCol && c.visible && Boolean(String(c.dataField).endsWith('description') || String(c.dataField).endsWith('_desc'))
        //     );
        //     if (!col) col = columns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('variant_dimens'));
        //     if (!col) col = columns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('item_name'));
        //     if (!col) col = columns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('entity_name'));
        //     if (!col) col = columns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('store_name'));
        //     if (!col) col = columns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('warehouse_name'));
        //     if (!col) col = columns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('job_title'));
        //     if (!col) col = columns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('business_unit'));
        //     if (!col) col = columns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('department'));
        //     if (!col) col = columns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('status'));
        //     if (!col) col = columns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('name'));
        //     if (!col) col = columns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('code'));
        //     if (!col) col = columns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('type'));

        //     if (col) {
        //         col.width = 'auto';
        //     } else {
        //         col = columns.find(
        //             (c) =>
        //                 !c.isSystemCol && !c.visible && Boolean(String(c.dataField).endsWith('description') || String(c.dataField).endsWith('_desc'))
        //         );
        //         if (col) {
        //             col.width = 'auto';
        //             col.visible = true;
        //         }
        //     }
        // }

        // isOK = columns.some((c) => !c.isSystemCol && c.visible && c.width === 'auto');
        // if (!isOK) {
        //     var maxCol = null;
        //     var maxWidth = 0;

        //     columns
        //         .filter((c) => !c.isSystemCol && c.visible && c.width !== 'auto')
        //         .forEach((c) => {
        //             if (typeof c.width === 'number' && parseFloat(c.width) > maxWidth) {
        //                 maxWidth = parseFloat(c.width);
        //                 maxCol = c;
        //             } else if (typeof c.minWidth === 'number' && parseFloat(c.minWidth) > maxWidth) {
        //                 maxWidth = parseFloat(c.minWidth);
        //                 maxCol = c;
        //             }
        //         });
        //     if (maxCol) maxCol.width = 'auto';
        // }

        // columns = columns.map((c) => {
        //     if (!c.isSystemCol) {
        //         if (c.width === 'auto') c.width = undefined;
        //         else if (!c.width) c.width = 'auto';
        //     }
        //     return c;
        // });

        return columns;
    }, [
        isRender,
        config,
        isColumnVisible,
        props.showIndex,
        props.showDetail,
        props.showDetailPosition,
        props.showNote,
        props.showAttachments,
        props.showPriority,
        props.columns,
        props.customSelectionValue,
        props.rowActionWidth,
        props.formData,
        props.table,
        props.API,
        props.parentData,
        props.editorOptions
    ]);

    const mainColumns = useMemo(() => initColumns(), [initColumns]);

    const dsGetQueryFields = useCallback(
        (opts) => {
            var ar = [];
            if (opts && opts.isDownloading) {
                if (props.showImport && props.import && props.import.mapping instanceof Array) {
                    for (let i = 0; i < props.import.mapping.length; i++) {
                        const c = props.import.mapping[i];

                        var fieldName = null;
                        if (typeof c === 'string') {
                            fieldName = String(c);
                        } else if (typeof c === 'object' && c.name) fieldName = c.name;

                        var strAlias = null;

                        var cnfTableName = c.cnfTable ? c.cnfTable : props.table ? props.table : props.API ? props.API.entityName : null;
                        var cnfFieldName = c.cnfField ? c.cnfField : fieldName;
                        var found = config.getCnfField(cnfFieldName, cnfTableName);
                        if (found) strAlias = AntLocalization.translateText(AntCondition.getValue(props.parentData, found.label));

                        let obj = {
                            field: fieldName,
                            alias: strAlias ? strAlias : undefined
                        };
                        if (c.dataType) obj.dataType = c.dataType;
                        else if (found && found.dataType) obj.dataType = found.dataType;

                        ar.push(obj);
                    }
                } else if (props.columns instanceof Array)
                    for (let i = 0; i < props.columns.length; i++) {
                        const c = props.columns[i];

                        var fieldName = null;
                        if (typeof c === 'string') {
                            fieldName = String(c);
                        } else if (typeof c === 'object' && c.dataField) fieldName = c.dataField;

                        var col1 = mainColumns.find((c1) => c1.dataField === fieldName);
                        if (col1) {
                            var tableName = col1.cnfTable ? col1.cnfTable : props.table ? props.table : props.API ? props.API.entityName : null;

                            if ((col1.colType === 'join' || col1.colType === 'first' || col1.colType === 'last') && col1.fields instanceof Array) {
                                var ar2 = col1.fields.map((fField) => {
                                    let fFieldName = fField;
                                    if (fField && typeof fField === 'object' && fField.dataField) fFieldName = fField.dataField;

                                    let obj = {
                                        field: fFieldName,
                                        alias: fFieldName.charAt(0).toUpperCase() + fFieldName.slice(1).toLowerCase()
                                    };
                                    let found = config.getCnfField(fFieldName, tableName);
                                    if (found) {
                                        obj.alias = AntLocalization.translateText(AntCondition.getValue(props.parentData, found.label));
                                        obj.dataType = found.dataType;
                                    }

                                    return obj;
                                });
                                ar.push(...ar2);
                            } else {
                                var found = config.getCnfField(fieldName, tableName);
                                let obj = {
                                    field: fieldName,
                                    alias: col1 ? AntLocalization.translateText(col1.caption) : undefined
                                };
                                if (found && found.dataType) obj.dataType = found.dataType;
                                else if (col1.dataType) obj.dataType = col1.dataType;

                                ar.push(obj);
                            }
                        }
                    }
            } else {
                ar = ['created_at', 'checksum', 'id', 'code'];
                if (props.columns instanceof Array) {
                    for (let i = 0; i < props.columns.length; i++) {
                        const c = props.columns[i];

                        var fieldName = null;
                        if (typeof c === 'string') {
                            fieldName = String(c);
                        } else if (typeof c === 'object' && c.dataField) fieldName = c.dataField;

                        if (fieldName) {
                            var col1 = mainColumns.find((c1) => c1.dataField === fieldName);
                            if (
                                col1 &&
                                (col1.colType === 'join' || col1.colType === 'first' || col1.colType === 'last') &&
                                col1.fields instanceof Array
                            )
                                for (let j = 0; j < col1.fields.length; j++) {
                                    const fField = col1.fields[j];

                                    let fFieldName = fField;
                                    if (fField && typeof fField === 'object' && fField.dataField) fFieldName = fField.dataField;

                                    ar.push(fFieldName);
                                }
                            else ar.push(fieldName);
                        }
                    }

                    ar.push(
                        ...Array.from(props.columns, (c) =>
                            typeof c === 'object' && c.defaultValue && typeof c.defaultValue === 'object' && c.defaultValue.rowField
                                ? c.defaultValue.rowField
                                : undefined
                        )
                    );
                }
            }

            if (props.showDetail) {
                if (
                    typeof props.showDetail === 'object' &&
                    props.showDetail.key &&
                    !ar.includes(props.showDetail.key) &&
                    !ar.some((a) => a && typeof a === 'object' && a.field === props.showDetail.key)
                ) {
                    ar.push(props.showDetail.key);
                } else if (props.showDetail instanceof Array) {
                    for (let i = 0; i < props.showDetail.length; i++) {
                        const item = props.showDetail[i];

                        if (
                            typeof item === 'object' &&
                            item.key &&
                            !ar.includes(item.key) &&
                            !ar.some((a) => a && typeof a === 'object' && a.field === item.key)
                        ) {
                            ar.push(item.key);
                        }
                    }
                }
            }

            if (props.queryFields instanceof Array) ar.push(...props.queryFields);
            if (props.selectFields instanceof Array) ar.push(...props.selectFields);

            if (props.getQueryFields) {
                var fields = props.getQueryFields();
                if (fields instanceof Array) ar.push(...fields);
            }

            if (props.edit) ar.push(...AntJSON.getKeys(props.edit));
            if (props.showDetail) ar.push(...AntJSON.getKeys(props.showDetail));
            if (props.rowStyles) ar.push(...AntJSON.getKeys(props.rowStyles));
            if (props.rowActions) ar.push(...AntJSON.getKeys(props.rowActions));

            if (gridRowActions) ar.push(...AntJSON.getKeys(gridRowActions));

            ar = ar.flat();
            ar = ar
                .filter((v) => Boolean(v))
                .filter((v, index, self) => {
                    return self.indexOf(v) === index;
                });

            let tmpAr = ar.map((a) => {
                if (typeof a === 'object' && a) return a.field;
                return a;
            });
            tmpAr = tmpAr.filter((a) => config.hasField(a));
            tmpAr = AntArray.distinct(tmpAr);

            ar = ar.filter((a) => (typeof a === 'string' && tmpAr.includes(a)) || (typeof a === 'object' && a && tmpAr.includes(a.field)));

            return ar;
        },
        [
            config,
            mainColumns,
            gridRowActions,
            props.table,
            props.API,
            props.parentData,
            props.columns,
            props.showDetail,
            props.queryFields,
            props.selectFields,
            props.getQueryFields,
            props.edit,
            props.rowStyles,
            props.rowActions
        ]
    );

    const dsGetSearchConditions = useCallback(() => {
        return searchConditions.current ? JSON.parse(stringify(searchConditions.current)) : {};
    }, []);

    const dsGetParentSearchConditions = useCallback(() => {
        return searchParentConditions ? JSON.parse(stringify(searchParentConditions)) : {};
    }, [searchParentConditions]);

    const dsGetOrderBy = useCallback(() => {
        if (props.orderBy) return props.orderBy;
        return null;
    }, [props.orderBy]);

    const dsGetOrderings = useCallback(() => {
        if (props.ordering instanceof Array) return props.ordering;
        return null;
    }, [props.ordering]);

    const dsGetOrderType = useCallback(() => {
        if (props.orderType) return props.orderType;
        return null;
    }, [props.orderType]);

    // const initActions = useCallback(() => {
    //     var actions = props.actionItems instanceof Array ? props.actionItems : [];
    //     if (actions instanceof Array)
    //         actions = actions.map((c) => {
    //             var nItem = JSON.parse(stringify(c));

    //             nItem.text = AntLocalization.translateText(nItem.text);

    //             if (nItem.widget === 'ButtonGroup') {
    //                 if (nItem.items instanceof Array) {
    //                     nItem.items = nItem.items.filter((item) => {
    //                         return AntCondition.isVisible(props.parentData, item);
    //                     });
    //                 }

    //                 if (nItem.defaultSelect && (typeof nItem.defaultSelect === 'object' || nItem.defaultSelect instanceof Array))
    //                     nItem.defaultSelect = AntCondition.getValue(props.parentData, nItem.defaultSelect);
    //             }

    //             return nItem;
    //         });

    //     actions = actions.filter((item) => {
    //         var isVisible = AntCondition.isVisible(props.parentData, item);

    //         if (
    //             isVisible &&
    //             item.visibleOnMain &&
    //             props.parentData &&
    //             Object.keys(props.parentData).length > 0 &&
    //             (props.parentData.id || props.parentData.code)
    //         ) {
    //             let vObj = item.visibleOnMain;
    //             if (item.visibleOnMain instanceof Array) {
    //                 vObj = item.visibleOnMain.find(
    //                     (v) =>
    //                         v.table === props.parentTable ||
    //                         (v.table instanceof Array && v.table.includes(props.parentTable)) ||
    //                         (v.tables instanceof Array && v.tables.includes(props.parentTable))
    //                 );

    //                 if (vObj) vObj = vObj.value;
    //             }
    //             if (vObj)
    //                 isVisible = AntCondition.isVisible(props.parentData, {
    //                     visible: vObj
    //                 });
    //         }

    //         if (
    //             isVisible &&
    //             typeof item.visible === 'object' &&
    //             item.visible &&
    //             typeof item.visible.whenAction === 'object' &&
    //             item.visible.whenAction
    //         ) {
    //             isVisible = AntCondition.isVisible(searchConditions.current, {
    //                 visible: {
    //                     when: {
    //                         ...item.visible.whenAction
    //                     }
    //                 }
    //             });
    //         }
    //         return isVisible;
    //     });
    //     actions.forEach((item) => {
    //         item.editable = AntCondition.isEditable(props.parentData, item);
    //     });
    //     return actions;
    // }, [props.actionItems, props.parentData, isRender]);

    // const mainActions = useMemo(() => initActions(), [initActions]);

    const isAllowQuery = useCallback(() => {
        if (props.searchConditionsRequired && (!searchConditions.current || Object.keys(searchConditions.current).length === 0)) return false;

        if (props.isAllowQuery && typeof props.isAllowQuery === 'function') return props.isAllowQuery();

        return true;
    }, [props.searchConditionsRequired, props.isAllowQuery]);

    const getKeyField = useCallback(() => {
        return props.keyExpr ? props.keyExpr : 'id';
    }, [props.keyExpr]);

    const getEditedData = useCallback(() => {
        if (dataSource.current) return dataSource.current.getEditedData();
        return null;
    }, []);

    const getCachedData = useCallback(() => {
        if (dataSource.current) return dataSource.current.getCachedData();
        return null;
    }, []);

    const modifiedRows = useCallback(
        (inColumnOnly) => {
            var data = dataSource.current.getEditedData();
            if (data instanceof Array) {
                if (inColumnOnly && props.columns instanceof Array) {
                    for (let i = 0; i < data.length; i++) {
                        var row = data[i];
                        var keys = Object.keys(row);

                        for (let j = 0; j < keys.length; j++) {
                            const field = keys[j];

                            var isValid = field === props.keyExpr || (row[field] !== undefined && props.columns.some((c) => c.dataField === field));
                            if (!isValid) row[field] = undefined;
                        }
                    }
                }
            }
            return data;
        },
        [props.columns]
    );

    const cleanData = useCallback(() => {
        dataSource.current.reset(null, true, true);
    }, []);

    const refreshAndPaint = useCallback(async () => {
        if (grid.current && grid.current.instance) {
            await dataSource.current.willGetLastResult();
            grid.current.instance.refresh(true);
        }
    }, []);

    const isDataLoading = useCallback(() => {
        return Boolean(loading);
    }, [loading]);

    const isDataLoaded = useCallback(() => {
        return Boolean(loaded.current);
    }, []);

    const onDatasourceLoading = useCallback(() => {
        loading.current = true;
    }, []);

    const clearSelection = useCallback(() => {
        if (grid.current && grid.current.instance) grid.current.instance.clearSelection();
    }, []);

    const renderDetailLink = useCallback(
        (rowData) => {
            var ar = [];
            if (props.showDetail && props.showDetail instanceof Array) {
                for (let i = 0; i < props.showDetail.length; i++) {
                    const item = props.showDetail[i];
                    ar.push(item);
                }
            } else if (props.showDetail && typeof props.showDetail === 'object')
                ar.push({
                    when: props.showDetail.when,
                    whenType: props.showDetail.whenType,
                    url: props.showDetail.url,
                    key: props.showDetail.key
                });

            for (let i = 0; i < ar.length; i++) {
                const item = ar[i];

                if (item.when) {
                    var isValid = true;

                    var isValid = AntCondition.isValid(rowData, {
                        when: item.when,
                        whenType: item.whenType
                    });

                    if (!isValid) continue;
                }

                var url = item.url ? item.url : null;
                var key = null;

                if (url) {
                    if (item.key) {
                        key = item.key;
                        if (!rowData[key]) continue;
                    }

                    if (!key || !rowData[key]) key = 'code';
                    if (!key || !rowData[key]) key = 'id';
                    if (!key || !rowData[key]) key = props.keyExpr;

                    if (key && rowData[key]) {
                        var value = rowData[key];

                        var linkUrl = format('{0}/{1}', url, value);
                        return {
                            url: linkUrl,
                            value: value,
                            rowData: rowData
                        };
                    }
                }
            }

            return null;
        },
        [props.keyExpr, props.showDetail]
    );

    const showEditPopup = useCallback(
        async (id) => {
            return;

            if (editPopup.current) {
                var defaultObj = await editPopup.current.showById(id);
                if (props.edit && props.edit.onEditPrepared) props.edit.onEditPrepared(defaultObj);
            }
        },
        [props.edit]
    );

    const onRowDblClick = useCallback(
        (e) => {
            if (e && e.data) {
                var lnk = renderDetailLink(e.data);
                if (lnk && lnk.url) {
                    navigate(lnk.url);
                    return;
                }
            }
            if (e.data && e.data.id) showEditPopup(e.data.id);

            if (props.onRowDblClick) props.onRowDblClick(e);
        },
        [renderDetailLink, showEditPopup, props.onRowDblClick]
    );

    const onDataSourceEdited = useCallback(
        async (keyValue, values) => {
            var key = props.keyExpr ? props.keyExpr : 'id';

            if (props.allowAutoUpdate) {
                var obj = dataSource.current ? dataSource.current.getCachedItem(keyValue) : null;
                if (obj) {
                    var result = await props.API.postUpdateValidation(
                        {
                            [key]: keyValue,
                            checksum: obj.checksum
                        },
                        values
                    );
                    var error = config.translateFirstError(result, 'Dữ liệu không hợp lệ!');

                    if (!error) {
                        var result = await props.API.postUpdate(
                            {
                                [key]: keyValue,
                                checksum: obj.checksum
                            },
                            values
                        );
                        if (!result || result.error || !result.data || !result.data.updated)
                            error = config.translateFirstError(result, 'Dữ liệu không hợp lệ!');
                    }

                    // this.refresh(true);
                }
            } else {
                if (props.columns instanceof Array) {
                    var row = getEditedData().find((r) => r[key] === keyValue);
                    if (row) {
                        var cols = props.columns
                            .filter((col) => col.dataField)
                            .map((col) => {
                                return {
                                    ...col,
                                    index: col.formulaIndex !== undefined ? col.formulaIndex : 0
                                };
                            })
                            .sort((a, b) => (a.index > b.index ? 1 : -1));

                        for (let i = 0; i < cols.length; i++) {
                            const col = cols[i];
                            if (col.defaultValue && col.defaultValue.minValue !== undefined && row[col.dataField] === undefined) {
                                await dataSource.current.updateItem(keyValue, {
                                    [col.dataField]: col.defaultValue.minValue
                                });
                                return;
                            }
                            if (col.defaultValue && col.defaultValue.value !== undefined && row[col.dataField] === undefined) {
                                await dataSource.current.updateItem(keyValue, {
                                    [col.dataField]: col.defaultValue.value
                                });
                                return;
                            }

                            if (col.formula instanceof Array) {
                                var fm = col.formula[0];
                                var defaultNullValue =
                                    col.formula[1] !== undefined && col.formula[1] !== null && typeof col.formula[1] === 'number'
                                        ? col.formula[1]
                                        : 0;

                                var value = calculator.execNum(row, fm, defaultNullValue);
                                if (value !== row[col.dataField]) {
                                    await dataSource.current.updateItem(keyValue, { [col.dataField]: value }, { byPassEvent: true });
                                    row = getEditedData().find((r) => r[key] === keyValue);
                                }
                            }
                        }
                    }
                }
            }
            // if (!lockUpdatedEvent)
            if (props.onDataSourceEdited)
                props.onDataSourceEdited({
                    field: keyValue,
                    value: values
                });
        },
        [config, getEditedData, props.keyExpr, props.allowAutoUpdate, props.API, props.columns, props.onDataSourceEdited]
    );

    const resetVisibility = useCallback(
        (visible) => {
            if (grid.current && grid.current.instance) {
                var oldVisible = grid.current.instance.option('visible');
                if (oldVisible != visible) grid.current.instance.option('visible', visible);
            }
            if (props.showActionBar != false && actionBar.current) actionBar.current.resetVisibility(visible);
        },
        [props.showActionBar]
    );

    const resetDisabled = useCallback(
        (disabled) => {
            if (grid.current && grid.current.instance) {
                var oldDisabled = grid.current.instance.option('disabled');
                if (oldDisabled != disabled) grid.current.instance.option('disabled', disabled);
            }
            if (props.showActionBar != false && actionBar.current) actionBar.current.resetDisabled(disabled);
        },
        [props.showActionBar]
    );

    const getDataRowActions = useCallback(() => {
        if (dataSource.current && dataSource.current.isQuerried()) {
            let actions = dataSource.current
                .getCurrentData()
                .map((r) => (r.actions instanceof Array ? r.actions.filter((a) => Boolean(a.visible)).map((a) => a.name) : []))
                .flat();

            actions = actions.filter((a, i) => actions.indexOf(a) === i);
            return actions;
        }
        return null;
    }, []);

    const getActionColumnWidth = useCallback(() => {
        if (props.rowActionWidth) return props.rowActionWidth;

        if (dataSource.current && dataSource.current.isQuerried()) {
            let widths = dataSource.current
                .getCurrentData()
                .filter((row) => row.actions instanceof Array)
                .map((row) => {
                    row.actions = row.actions.filter((a) => Boolean(a.visible));
                    row.actions = row.actions.filter((a) => gridRowActions.some((rAct) => rAct.code === a.name));
                    return row;
                })
                .filter((row) => row.actions.length > 0)
                .map((row) => {
                    let width = gridRowActions
                        .filter((rAct) => row.actions.some((a) => rAct.code === a.name))
                        .map((rAct) => {
                            if (
                                [
                                    'actionDelete',
                                    'actionCancel',
                                    'actionPost',
                                    'actionApprove',
                                    'actionReject',
                                    'actionClose',
                                    'actionRelease'
                                ].includes(rAct.code) &&
                                !rAct.name
                            )
                                rAct.width = 30;
                            return rAct;
                        })
                        .reduce((total, i) => total + (i.width ? i.width : 60) + 8, 0);

                    return width;
                });

            return Math.max.apply(Math, widths);
        }
        return 0;
    }, [props.rowActionWidth, gridRowActions]);

    const resetPager = useCallback(() => {
        if (grid.current && grid.current.instance && props.pagerHideable) {
            var hidePager = dataSource.current && dataSource.current.isOnePageOnly();

            var newValue = !hidePager;

            var oldValue = grid.current.instance.option('paging.visible');
            if (oldValue !== newValue) grid.current.instance.option('pager.visible', newValue);
        }
    }, []);

    const resetColumnVisibility = useCallback(() => {
        if (grid.current && grid.current.instance) {
            for (let i = 0; i < mainColumns.length; i++) {
                let col = mainColumns[i];
                if (!col.isSystemCol || col.name === 'priority' || col.name === 'actions') {
                    col.visible = isColumnVisible(col);
                    var oldValue = grid.current.instance.columnOption(col.name, 'visible');
                    if (oldValue !== col.visible) {
                        grid.current.instance.columnOption(col.name, 'visible', col.visible);
                    }
                }
            }
        }
    }, [isColumnVisible, mainColumns]);

    const resetColumnWidth = useCallback(() => {
        if (grid.current && grid.current.instance) {
            var isOK = mainColumns.some((c) => !c.isSystemCol && c.visible && c.width === undefined);
            if (!isOK) {
                var col = mainColumns.find(
                    (c) =>
                        !c.isSystemCol && c.visible && Boolean(String(c.dataField).endsWith('description') || String(c.dataField).endsWith('_desc'))
                );
                if (!col) col = mainColumns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('variant_dimens'));
                if (!col) col = mainColumns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('item_name'));
                if (!col) col = mainColumns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('entity_name'));
                if (!col) col = mainColumns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('store_name'));
                if (!col) col = mainColumns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('warehouse_name'));
                if (!col) col = mainColumns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('job_title'));
                if (!col) col = mainColumns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('business_unit'));
                if (!col) col = mainColumns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('department'));
                // if (!col) col = mainColumns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('status'));
                if (!col) col = mainColumns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('name'));
                if (!col) col = mainColumns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('code'));
                if (!col) col = mainColumns.find((c) => !c.isSystemCol && c.visible && String(c.dataField).endsWith('type'));

                if (col) {
                    col.width = undefined;
                    var oldValue = grid.current.instance.columnOption(col.name, 'width');
                    if (oldValue !== col.width) {
                        grid.current.instance.columnOption(col.name, 'width', col.width);
                    }
                } else {
                    col = mainColumns.find(
                        (c) =>
                            !c.isSystemCol &&
                            !c.visible &&
                            Boolean(String(c.dataField).endsWith('description') || String(c.dataField).endsWith('_desc'))
                    );
                    if (col) {
                        col.width = undefined;
                        col.visible = true;

                        var oldValue = grid.current.instance.columnOption(col.name, 'width');
                        if (oldValue !== col.width) grid.current.instance.columnOption(col.name, 'width', col.width);

                        var oldValue = grid.current.instance.columnOption(col.name, 'visible');
                        if (oldValue !== col.visible) grid.current.instance.columnOption(col.name, 'visible', col.visible);
                    }
                }
            }

            isOK = mainColumns.some((c) => !c.isSystemCol && c.visible && c.width === undefined);
            if (!isOK) {
                var maxCol = null;
                var maxWidth = 0;

                for (let i = 0; i < mainColumns.length; i++) {
                    const c = mainColumns[i];
                    if (!c.isSystemCol) {
                        if (c.visible && c.width && typeof c.width === 'number' && parseFloat(c.width) > maxWidth) {
                            maxWidth = parseFloat(c.width);
                            maxCol = c;
                        } else if (c.visible && c.minWidth && typeof c.minWidth === 'number' && parseFloat(c.minWidth) > maxWidth) {
                            maxWidth = parseFloat(c.minWidth);
                            maxCol = c;
                        }
                    }
                }
                if (maxCol) {
                    maxCol.width = undefined;

                    var oldValue = grid.current.instance.columnOption(maxCol.name, 'width');
                    if (maxCol && oldValue !== maxCol.width) grid.current.instance.columnOption(maxCol.name, 'width', maxCol.width);
                }
            }

            if (gridRowActions instanceof Array)
                mainColumns.forEach((col) => {
                    if (col.isSystemCol && col.name === 'actions') {
                        var newValue = getActionColumnWidth();
                        if (newValue) {
                            var oldValue = grid.current.instance.columnOption(col.name, 'width');
                            if (oldValue !== newValue) grid.current.instance.columnOption(col.name, 'width', newValue);
                        }

                        var actions = getDataRowActions();
                        if (actions instanceof Array) {
                            var oldValue = grid.current.instance.columnOption(col.name, 'visible');
                            if (oldValue !== Boolean(actions.length))
                                grid.current.instance.columnOption(col.name, 'visible', Boolean(actions.length));
                        }
                    }
                });
        }
    }, [mainColumns, gridRowActions, getActionColumnWidth, getDataRowActions]);

    const resetColumnEditable = useCallback(() => {
        if (grid.current) {
            if (grid.current.instance) {
                mainColumns.forEach((col) => {
                    if (!col.isSystemCol) {
                        var editable = Boolean(col.allowEditing);
                        var rawCol = props.columns.find((c) => c.dataField === col.dataField);
                        if (rawCol && rawCol.rawConfig) rawCol = rawCol.rawConfig;

                        if (rawCol) {
                            editable = rawCol.editable !== undefined ? Boolean(rawCol.editable) : editable;

                            if (typeof rawCol.editable === 'object') {
                                if (rawCol.editable.type === 'action' && rawCol.editable.field) {
                                    editable = false;
                                    var condKey = Object.keys(searchConditions.current).find((k) => k === rawCol.editable.field);
                                    if (condKey && searchConditions.current[condKey] !== undefined)
                                        editable = searchConditions.current[condKey] === rawCol.editable.value;
                                } else if (props.parentData) {
                                    editable = AntCondition.isEditable(props.parentData, rawCol);
                                }
                            }
                        }

                        var oldValue = grid.current.instance.columnOption(col.name, 'allowEditing');
                        if (oldValue !== editable) grid.current.instance.columnOption(col.name, 'allowEditing', editable);
                    }
                });
            }
        }
    }, [props.columns, props.parentData, mainColumns]);

    const renderCheckboxCell = useCallback((cell) => {
        return <CheckBox value={cell.value} hoverStateEnabled={false} activeStateEnabled={false} focusStateEnabled={false} />;
    }, []);

    // const renderDetailCell = useCallback(
    //     (cell) => {
    //         var row = cell.row;
    //         var rowData = cell.row.data;

    //         var lnk = renderDetailLink(rowData);
    //         if (lnk) return <AntGridLink value={lnk.value} row={row} rowData={rowData} linkUrl={lnk.url} newWindow={props.showDetailOnNewWindow} />;

    //         return <div></div>;
    //     },
    //     [renderDetailLink, props.showDetailOnNewWindow]
    // );

    const renderCustomFormatCell = useCallback(
        (cell) => {
            let fieldName = cell.column.dataField;

            var row = cell.row;
            var rowData = cell.row.data;

            let displayValue = rowData[fieldName];
            if (cell.column.calculateDisplayValue) displayValue = cell.column.calculateDisplayValue(rowData);

            let oStyle = {};

            if (rowData.isBold) oStyle.fontWeight = 'bold';

            if (rowData.format) {
                if (rowData.format.marginLeft) oStyle.marginLeft = rowData.format.marginLeft;
            }
            return <div style={oStyle}>{displayValue}</div>;
        },
        [renderDetailLink, props.showDetailOnNewWindow]
    );

    const renderBoldCell = useCallback(
        (cell) => {
            let fieldName = cell.column.dataField;

            var row = cell.row;
            var rowData = cell.row.data;

            let displayValue = rowData[fieldName];
            if (cell.column.calculateDisplayValue) displayValue = cell.column.calculateDisplayValue(rowData);

            if (rowData.isBold) return <div style={{ fontWeight: 'bold' }}>{displayValue}</div>;
            return <div>{displayValue}</div>;
        },
        [renderDetailLink, props.showDetailOnNewWindow]
    );

    const onCellPrepared = useCallback(
        (e) => {
            if (e.rowType === 'data') {
                if (props.cellStyles instanceof Array)
                    for (let i = 0; i < props.cellStyles.length; i++) {
                        const cellStyle = props.cellStyles[i];

                        if (!cellStyle.dataField || cellStyle.dataField === e.column.dataField) {
                            if (cellStyle.when && typeof cellStyle.when === 'object') {
                                var isValid = AntCondition.isValid(e.data, {
                                    when: cellStyle.when,
                                    whenType: cellStyle.whenType
                                });

                                if (isValid) {
                                    e.cellElement.style.backgroundColor = cellStyle.backgroundColor;
                                    e.cellElement.style.color = cellStyle.textColor;
                                    return;
                                }
                            }
                        }
                    }

                if (props.rowStyles instanceof Array)
                    for (let i = 0; i < props.rowStyles.length; i++) {
                        const rowStyle = props.rowStyles[i];

                        if (rowStyle.when && typeof rowStyle.when === 'object') {
                            var isValid = AntCondition.isValid(e.data, {
                                when: rowStyle.when,
                                whenType: rowStyle.whenType
                            });

                            if (isValid) {
                                e.cellElement.style.backgroundColor = rowStyle.backgroundColor;
                                e.cellElement.style.color = rowStyle.textColor;
                                e.cellElement.style.fontWeight = rowStyle.fontWeight;
                                return;
                            }
                        }
                    }
            }
        },
        [props.cellStyles]
    );

    const renderContentCell = useCallback((cell) => {
        // console.log('ant-log-cell=', cell);
    }, []);

    // const renderLinkCell = useCallback(
    //     (cell) => {
    //         var dataField = cell.column.dataField;
    //         var value = cell.value;
    //         var row = cell.row;
    //         var rowData = cell.row.data;

    //         var linkUrl = '';
    //         var keyField = dataField;
    //         if (props.columns && props.columns instanceof Array) {
    //             var field = props.columns.filter((col) => col.dataField == dataField)[0];
    //             if (field.link) {
    //                 linkUrl = field.link.url;
    //                 if (field.link.keyField) keyField = field.link.keyField;
    //             }
    //         }

    //         if (!linkUrl.startsWith('/')) linkUrl = '/' + linkUrl;
    //         if (!linkUrl.endsWith('/')) linkUrl = linkUrl + '/';
    //         linkUrl = format('{0}{2}', linkUrl, keyField, value);
    //         return (
    //             <AntGridLink
    //                 text={value}
    //                 field={dataField}
    //                 value={value}
    //                 row={row}
    //                 rowData={rowData}
    //                 linkUrl={linkUrl}
    //                 // onClick={this.handleLinkClicked}
    //             />
    //         );
    //     },
    //     [props.columns]
    // );

    const renderNoteCell = useCallback((cell) => {
        var dataField = cell.column.dataField;
        var value = cell.value;
        var row = cell.row;
        var rowData = cell.row.data;

        // if (row.rowIndex % 5 == 1) rowData.note = "nsdsdgsdg";
        // if (row.rowIndex % 5 == 3) rowData.note = "urge sfd sdgsdnt";

        if (!rowData || !rowData.note || String(rowData.note).trim() == '') return <div></div>;

        var notes = rowData.note.split('\n');

        var id = 'ant-grid-note-' + row.rowIndex;

        return (
            <div>
                <Button
                    className="ant-grid-icon ant-icon-note"
                    id={id}
                    type="normal"
                    stylingMode="text"
                    focusStateEnabled={false}
                    hoverStateEnabled={false}
                    activeStateEnabled={false}
                >
                    <i className={'dx-icon dx-icon-comment'}></i>
                </Button>
                <Tooltip
                    target={`#${id}`}
                    className="ant-tooltip"
                    hideEvent="mouseleave"
                    showEvent={{
                        name: 'mouseenter dxclick keyup'
                    }}
                    hideOnOutsideClick={true}
                >
                    <div>
                        {notes.map((item, key) => {
                            if (key < notes.length - 1)
                                return (
                                    <div>
                                        <caption>{item}</caption>
                                        <br />
                                    </div>
                                );
                            else
                                return (
                                    <div>
                                        <caption>{item}</caption>
                                    </div>
                                );
                        })}
                    </div>
                </Tooltip>
            </div>
        );
    }, []);

    const renderPriorityCell = useCallback(
        (cell) => {
            var dataField = cell.column.dataField;
            var value = cell.value;
            var row = cell.row;
            var rowData = cell.row.data;

            // if (row.rowIndex % 6 == 1) rowData.priority = 'high';
            // if (row.rowIndex % 6 == 3) rowData.priority = 'urgent';

            var priorityField = props.priorityField ? props.priorityField : 'priority';

            if (!rowData || !rowData[priorityField] || String(rowData[priorityField]).trim() == '') return <div></div>;

            var priority = '';
            if (rowData[priorityField] === 'Lowest') priority = 'lowest';
            if (rowData[priorityField] === 'Low') priority = 'low';
            if (rowData[priorityField] === 'Normal') priority = 'normal';
            if (rowData[priorityField] === 'High') priority = 'high';
            if (rowData[priorityField] === 'Highest') priority = 'highest';

            if (priority !== 'high' && priority !== 'highest') return <div></div>;

            var id = 'ant-grid-priority-' + row.rowIndex;

            return (
                <div>
                    <Button
                        className={`ant-grid-icon ant-icon-priority-${priority}`}
                        id={id}
                        type="normal"
                        stylingMode="text"
                        focusStateEnabled={false}
                        hoverStateEnabled={false}
                        activeStateEnabled={false}
                    >
                        {/* <i className={`dx-icon dx-icon-${priority == 'high' ? 'favorites' : 'warning'}`}></i> */}
                        <i className={`dx-icon dx-icon-favorites`}></i>
                    </Button>
                    <Tooltip
                        target={`#${id}`}
                        className="ant-tooltip"
                        hideEvent="mouseleave"
                        showEvent={{
                            name: 'mouseenter dxclick keyup'
                        }}
                        hideOnOutsideClick={true}
                    >
                        <div>
                            {priority === 'high' && (
                                <div>
                                    <caption>{AntLocalization.translateText({ vi: 'Ưu tiên', en: 'Priority', fr: 'Priorité', es: 'Prioridad', id: 'Prioritas', ja: '優先度', zh: '优先级', ko: '우선순위', hi: 'प्राथमिकता', ar: 'أولوية' })}</caption>
                                </div>
                            )}
                            {priority === 'highest' && (
                                <div>
                                    <caption>{AntLocalization.translateText({ vi: 'Ưu tiên', en: 'Priority', fr: 'Priorité', es: 'Prioridad', id: 'Prioritas', ja: '優先度', zh: '优先级', ko: '우선순위', hi: 'प्राथमिकता', ar: 'أولوية' })}</caption>
                                </div>
                            )}
                        </div>
                    </Tooltip>
                </div>
            );
        },
        [props.priorityField]
    );

    const renderAttachmentCell = useCallback((cell) => {
        var dataField = cell.column.dataField;
        var value = cell.value;
        var row = cell.row;
        var rowData = cell.row.data;

        // if (!rowData || !rowData.attach || rowData.attach instanceof Array == false) return <div></div>;

        var id = 'ant-grid-attach-' + row.rowIndex;

        return (
            <div>
                <Button
                    className="ant-grid-icon ant-icon-attach"
                    id={id}
                    type="normal"
                    stylingMode="text"
                    focusStateEnabled={false}
                    hoverStateEnabled={false}
                    activeStateEnabled={false}
                >
                    <i className={'dx-icon dx-icon-file'}></i>
                </Button>
            </div>
        );
    }, []);
    // const renderCellEditor = useCallback((cell) => {
    //     var col = cell.column;
    //     var row = cell.row;
    //     var rowData = cell.data;
    //     var dataField = cell.column.dataField;

    //     var cnfField = null;
    //     if (this.state.cnfFields instanceof Array) cnfField = this.state.cnfFields.find((f) => f.field === dataField);

    //     var value = cell.value;
    //     var colType = col.dataType;
    //     var colEditor = col.dataType;
    //     var colEditorOptions = col.editorOptions;
    //     if (!colType && props.columns instanceof Array) {
    //         var found = props.columns.find((f) => f.field === dataField);
    //         if (found && found.dataType) colType = found.dataType;
    //         if (found && found.editor) colEditor = found.editor;
    //         if (found && found.editorOptions) colEditorOptions = found.editorOptions;
    //     }
    //     if (!colType && cnfField && cnfField.dataType) colType = cnfField.dataType;

    //     let onCellValueChanged = this.onCellValueChanged.bind(this, cell);

    //     if (colEditor == 'textArea')
    //         return (
    //             <TextArea
    //                 {...colEditorOptions}
    //                 defaultValue={value}
    //                 value={value}
    //                 onValueChanged={onCellValueChanged}
    //                 onFocusIn={(e) => {
    //                     let inputEl = e.element.querySelector('.dx-texteditor-input');
    // if (inputEl) {
    //     inputEl.selectionStart = 0;
    //     inputEl.selectionEnd = inputEl.value.length;
    // }
    //                 }}
    //             />
    //         );

    //     if (colEditor == 'checkBox' || colType == 'bool' || colType == 'boolean')
    //         return <CheckBox {...colEditorOptions} defaultValue={value} value={value} onValueChanged={onCellValueChanged} />;

    //     if (colEditor == 'dxSelectBox') {
    //         var allowNew = false;
    //         var datasource = [];
    //         if (col.lookup) {
    //             if (col.lookup.allowNew) allowNew = col.lookup.allowNew;
    //             if (col.lookup.values instanceof Array) datasource = col.lookup.values;
    //         } else if (cnfField && cnfField.lookup) {
    //             if (cnfField.lookup.allowNew) allowNew = cnfField.lookup.allowNew;
    //             if (cnfField.lookup.values instanceof Array) datasource = cnfField.lookup.values;
    //         }
    //         return (
    //             <SelectBox
    //                 items={datasource}
    //                 acceptCustomValue={allowNew}
    //                 placeholder={'...'}
    //                 showClearButton={true}
    //                 {...colEditorOptions}
    //                 noDataText={'Không có dữ liệu'}
    //                 defaultValue={value}
    //                 value={value}
    //                 onValueChanged={onCellValueChanged}
    //             />
    //         );
    //     }

    //     if (colEditor == 'antDropDownGrid') {
    //         var allowNew = false;
    //         var valueField = null;
    //         var displayField = null;
    //         var datasource = [];
    //         if (col.lookup) {
    //             if (col.lookup.allowNew) allowNew = col.lookup.allowNew;
    //             if (col.lookup.valueField) valueField = col.lookup.valueField;
    //             if (col.lookup.displayField) displayField = col.lookup.displayField;
    //             if (col.lookup.values instanceof Array) datasource = col.lookup.values;
    //         } else if (cnfField && cnfField.lookup) {
    //             if (cnfField.lookup.allowNew) allowNew = cnfField.lookup.allowNew;
    //             if (cnfField.lookup.valueField) valueField = cnfField.lookup.valueField;
    //             if (cnfField.lookup.displayField) displayField = cnfField.lookup.displayField;
    //             if (cnfField.lookup.values instanceof Array) datasource = cnfField.lookup.values;
    //         }

    //         return (
    //             <AntDropDownGrid
    //                 gridOptions={{
    //                     dataSource: datasource,
    //                     valueExpr: valueField,
    //                     displayExpr: displayField,
    //                     showClearButton: true,
    //                     ...colEditorOptions,
    //                     noDataText: 'Không có dữ liệu'
    //                 }}
    //                 width={col.lookup.width}
    //                 defaultValue={value}
    //                 value={value}
    //                 onValueChanged={onCellValueChanged}
    //             />
    //         );
    //     }

    //     if (colType === 'float' || colType === 'decimal') {
    //         return (
    //             <NumberBox
    //                 {...colEditorOptions}
    //                 format={'#,##0.' + String('#').repeat(colEditorOptions && colEditorOptions.decimalDigit ? colEditorOptions.decimalDigit : 2)}
    //                 value={value}
    //                 onValueChanged={onCellValueChanged}
    //             />
    //         );
    //     }

    //     if (colType === 'day' || (colType === 'int' && col.dataTypeDisplay === 'day')) {
    //         return <NumberBox {...colEditorOptions} format={'#,##0 ngày'} value={value} onValueChanged={onCellValueChanged} />;
    //     }

    //     if (colType === 'month' || (colType === 'int' && col.dataTypeDisplay === 'month')) {
    //         return <NumberBox {...colEditorOptions} format={'#,##0 tháng'} value={value} onValueChanged={onCellValueChanged} />;
    //     }

    //     if (colType === 'year' || (colType === 'int' && col.dataTypeDisplay === 'year')) {
    //         return <NumberBox {...colEditorOptions} format={'#,##0 năm'} value={value} onValueChanged={onCellValueChanged} />;
    //     }

    //     if (colType === 'period' || (colType === 'int' && col.dataTypeDisplay === 'period')) {
    //         return <NumberBox {...colEditorOptions} format={'#,##0 kỳ'} value={value} onValueChanged={onCellValueChanged} />;
    //     }

    //     if (colType === 'fixedPoint' || colType === 'int') {
    //         // return <NumberBox {...colEditorOptions} format={{ type: 'fixedPoint' }} value={value} onValueChanged={onCellValueChanged} />;
    //         return <NumberBox {...colEditorOptions} format={'#,##0'} value={parseInt(value)} onValueChanged={onCellValueChanged} />;
    //     }
    //     if (colType === 'percent') {
    //         return (
    //             <NumberBox
    //                 {...colEditorOptions}
    //                 format={{
    //                     type: 'percent',
    //                     precision: colEditorOptions && colEditorOptions.decimalDigit ? parseInt(colEditorOptions.decimalDigit) : 0
    //                 }}
    //                 value={parseFloat(value)}
    //                 onValueChanged={onCellValueChanged}
    //             />
    //         );
    //     }

    //     if (colType === 'currency') {
    //         return <NumberBox {...colEditorOptions} format={'#,##0 đ'} value={parseInt(value)} onValueChanged={onCellValueChanged} />;
    //     }

    //     if (colType === 'phone') {
    //         return (
    //             <TextBox
    //                 {...colEditorOptions}
    //                 mask="(+84) X000 000 000"
    //                 maskRules={{ X: /[02-9]/ }}
    //                 value={value}
    //                 onValueChanged={onCellValueChanged}
    //             />
    //         );
    //     }

    //     var mode = 'text';
    //     if (colType == 'password') mode = 'password';
    //     return <TextBox {...colEditorOptions} mode={mode} defaultValue={value} value={value} onValueChanged={onCellValueChanged} />;
    // });

    const onInitialized = useCallback((e) => {
        e.component.columnOption('command:adaptive', 'visible', false);
    }, []);

    const onContentReady = useCallback((e) => {
        reconcileGridHeaderLayout(e?.component || grid.current?.instance);
    }, []);

    const onCellClick = useCallback(
        (e) => {
            if (!e || !e.column) return;

            if (e.rowType === 'header') {
                if (e.component) {
                    let colId = e.column.dataField ? e.column.dataField : e.columnIndex;

                    if (sortByColumn.current && sortByColumn.current !== e.column.dataField) {
                        e.component.beginUpdate();
                        e.component.clearSorting();
                        e.component.columnOption(sortByColumn.current, {
                            sortOrder: null
                        });
                        e.component.endUpdate();
                    }

                    if (e.column.sortOrder === 'asc') {
                        setTimeout(
                            (comp, colId) => {
                                if (sortType.current !== 'desc') {
                                    comp.beginUpdate();
                                    comp.clearSorting();
                                    comp.columnOption(colId, {
                                        sortOrder: 'desc'
                                    });
                                    comp.endUpdate();
                                }
                            },
                            300,
                            e.component,
                            colId
                        );
                    }
                    if (e.column.sortOrder === 'desc') {
                        setTimeout(
                            (comp, colId) => {
                                if (sortType.current !== 'asc') {
                                    comp.beginUpdate();
                                    comp.clearSorting();
                                    comp.columnOption(colId, {
                                        sortOrder: 'asc'
                                    });
                                    comp.endUpdate();
                                }
                            },
                            300,
                            e.component,
                            colId
                        );
                    }
                }

                return;
            }

            if (props.onCellClick) props.onCellClick({ table: props.table, mainData: e.data });
        },
        [props.onCellClick]
    );

    const onOptionChanged = useCallback(
        (e) => {
            if (e.name === 'columns' && String(e.fullName).endsWith('].sortOrder')) {
                var colIndex = parseInt(String(e.fullName).replace('columns[', '').replace('].sortOrder', ''));
                var fieldName = grid.current && grid.current.instance ? grid.current.instance.columnOption(colIndex).dataField : undefined;
                // if (fieldName && (fieldName != sortByColumn.current || e.value != sortType.current)) {
                if (fieldName) {
                    sortByColumn.current = fieldName;
                    sortType.current = e.value;
                }
            }

            if (props.onOptionChanged) props.onOptionChanged(e);
        },
        [props.onOptionChanged]
    );

    const resetUI = useCallback(
        (opts) => {
            // if (loading.current || !grid.current || !grid.current.instance || !grid.current.instance.option('visible')) {
            //     setTimeout(() => {
            //         resetUI();
            //     }, 200);

            //     return;
            // }

            if (!opts || !opts.bysPassUpdate) beginUpdate();
            // resetPager();
            resetColumnVisibility();
            resetColumnWidth();

            if (!opts || !opts.bysPassUpdate) endUpdate();
        },
        [beginUpdate, resetPager, resetColumnVisibility, resetColumnWidth, endUpdate]
    );

    const autoResetUI = useCallback(
        (opts) => {
            resetUI({ bysPassUpdate: opts?.bysPassUpdate });

            if (!opts || !opts.byPassTimer) {
                if (autoResetUITimer.current) clearInterval(autoResetUITimer.current);
                autoResetUITimer.current = setInterval(() => {
                    resetUI({ byPassActionBar: true });
                }, 1 * 1000);
            }
        },
        [resetUI]
    );

    const generateSearchConditions = useCallback(
        (opts) => {
            let objS = {};

            if (props.searchCategories1)
                objS = selectedCats1.reduce((obj, c) => {
                    if (obj[c.field] !== undefined) obj[c.field].push(c.value);
                    else obj[c.field] = [c.value];
                    return obj;
                }, objS);

            Object.keys(objS).forEach((k) => {
                if (objS[k] instanceof Array && objS[k].length === 1) objS[k] = objS[k][0];
            });

            let newObj = {
                ...formSearchConditions
            };

            if (props.searchConditions) {
                if (typeof props.searchConditions === 'function') {
                    var obj = props.searchConditions();
                    if (obj)
                        newObj = {
                            ...newObj,
                            ...obj
                        };
                } else {
                    newObj = {
                        ...newObj,
                        ...props.searchConditions
                    };
                }
            }

            if (props.searchFields instanceof Array && props.searchFields.length > 0) {
                Object.keys(newObj).map((k) => {
                    var found = props.searchFields.find((f) => typeof f === 'object' && f.alias && f.field === k);
                    if (found) {
                        newObj[found.alias] = newObj[k];
                        delete newObj[k];
                    }
                });

                Object.keys(newObj).map((k) => {
                    var found = props.searchFields.find(
                        (f) =>
                            f === k ||
                            f === k + '_oneMonth' ||
                            f === k + '_oneYear' ||
                            f === k + '_startDate' ||
                            f === k + '_startMonth' ||
                            f === k + '_startYear' ||
                            f === k + '_endDate' ||
                            f === k + '_endMonth' ||
                            f === k + '_endYear' ||
                            k === f + '_oneMonth' ||
                            k === f + '_oneYear' ||
                            k === f + '_startDate' ||
                            k === f + '_startMonth' ||
                            k === f + '_startYear' ||
                            k === f + '_endDate' ||
                            k === f + '_endMonth' ||
                            k === f + '_endYear' ||
                            (typeof f === 'object' && f.alias === k)
                    );

                    if (!found && props.actionItems instanceof Array) found = props.actionItems.find((f) => f.name === k);

                    if (!found) newObj[k] = undefined;
                });
            }

            newObj = { ...newObj, ...objS };

            Object.keys(newObj).map((k) => {
                if (newObj[k] !== null && typeof newObj[k] === 'object') newObj[k] = AntCondition.getValueFromSession(newObj[k]);
            });

            Object.keys(newObj).map((k) => {
                if (newObj[k] === null || newObj[k] === '') newObj[k] = undefined;
            });

            Object.keys(newObj).forEach((key) => {
                if (newObj[key] === undefined) {
                    delete newObj[key];
                }
            });

            Object.keys(newObj).forEach((key) => {
                if (newObj[key] instanceof Array) {
                    newObj[key + '_search_inner_join'] = true;
                }
            });

            if (props.isSearching) newObj.isSearching = true;

            if (!opts || !opts.byPassCheckActions) {
                if (gridRowActions instanceof Array && gridRowActions.length > 0) {
                    newObj.checkActions = gridRowActions.map((a) => a.code);
                }
            }

            if (props.FKField && props.parentData) {
                var childValue = props.parentIDField ? props.parentData[props.parentIDField] : props.parentData.code;
                newObj[props.FKField] = childValue;
            }

            searchConditions.current = newObj;
            if (stringify(newObj) !== stringify(finalSearchConditions)) setFinalSearchConditions(newObj);

            return newObj;
        },
        [
            finalSearchConditions,
            props.searchConditions,
            formSearchConditions,
            props.actionItem,
            props.searchFields,
            props.isSearching,
            props.showRowActions,
            props.rowActionPack,
            props.rowActionWidth,
            props.rowActions,
            gridRowActions,
            props.parentData,
            selectedCats1
        ]
    );

    const forceReload = useCallback(
        async (opts) => {
            if (
                opts?.allowBackground !== true &&
                (!isForeground.current || (typeof document !== 'undefined' && document.visibilityState === 'hidden'))
            )
                return false;
            if (opts && opts.isResetUI) beginUpdate();

            generateSearchConditions();

            if (grid.current && grid.current.instance) {
                grid.current.instance.refresh(true);
            }
            if (opts && opts.isResetUI) await resetUI({ bysPassUpdate: true });
            // setTimeout(() => {
            //     resetUI();
            // }, 200);
        },
        [generateSearchConditions, resetUI, beginUpdate, endUpdate]
    );

    const onAction = useCallback(
        (e) => {
            if (e.name) forceReload();

            if (props.onAction && typeof props.onAction === 'function') props.onAction(e);
        },
        [props.onAction, forceReload]
    );

    const refresh = useCallback(
        (changesOnly) => {
            forceReload();

            if (grid.current && grid.current.instance) {
                grid.current.instance.refresh(changesOnly);
            }

            // forceRender();
        },
        [forceReload]
    );

    const reload = useCallback(
        async (opts) => {
            refresh(true);
        },
        [clearSelection, isRemotePaging, refresh]
    );

    const onRowAction = useCallback(
        async (e, done) => {
            if (props.onRowAction) {
                let close = await props.onRowAction(e);
                if (close) {
                    if (done) done();
                    return;
                }
            }

            let actionName = e.actionId;
            if (actionName === 'actionCancel') actionName = 'cancel';
            if (actionName === 'actionDelete') actionName = 'delete';
            if (actionName === 'actionRelease') actionName = 'release';
            if (actionName === 'actionClose') actionName = 'close';
            if (actionName === 'actionApprove') actionName = 'approve';
            if (actionName === 'actionPost') actionName = 'post';
            if (actionName === 'actionReject') actionName = 'reject';

            var btn = gridRowActions instanceof Array ? gridRowActions.find((a) => a.code === e.actionId) : null;
            if (!btn) {
                if (done) done();
                return;
            }

            var actAPI = btn.API ? btn.API : props.API;

            var result;

            if (props.rowActionCustomData) {
                let data = props.rowActionCustomData(e);
                result = await actAPI.postActionWithData(actionName, data);
            } else {
                result = await actAPI.postAction(actionName, e.data.code, e.data.id);
            }

            // Lời xoá bị luật configDelete chặn: hiện lý do của luật (trước đây lưới chỉ nạp lại, không báo gì).
            if (result && typeof result.error === 'string' && result.error && actionName === 'delete') notify(result.error, 'error', 5000);

            if (result && result.data) {
                var code = result.data.code;

                // if (btn && btn.navigateLink && code) {
                //     var value;
                //     var link;

                //     if (btn.navigateLink instanceof Array) {
                //         btn.navigateLink.forEach((l) => {
                //             if (l && l.link) {
                //                 if (l.when && typeof l.when === 'object') {
                //                     var isValid = AntCondition.isValid(result.data, {
                //                         when: l.when,
                //                         whenType: l.whenType
                //                     });
                //                     if (!isValid) return;
                //                 }
                //                 value = l.field ? result.data[l.field] : result.data.code;
                //                 link = String(l.link);
                //             }
                //         });
                //     } else {
                //         value = btn.navigateField ? result.data[btn.navigateField] : result.data.code;
                //         link = String(btn.navigateLink);
                //     }

                //     if (link && value !== undefined && value !== null) {
                //         if (!link.startsWith('/')) link = '/' + link;
                //         if (!link.endsWith('/')) link = link + '/';
                //         link = link + value;
                //         navigate(link);
                //     }
                // }
            }
            if (btn && (!btn.opts || !btn.opts.byPassRefreshGrid)) {
                reload();

                if (afterActionRefreshTimeout.current) clearTimeout(afterActionRefreshTimeout.current);
                afterActionRefreshTimeout.current = setTimeout(() => {
                    reload();
                    if (grid.current && grid.current.instance) grid.current.instance.repaint();
                }, 1500);
            }
            if (props.afterRowAction) props.afterRowAction(result);

            if (done) done();
        },
        [reload, props.onRowAction, gridRowActions, props.API, props.rowActionCustomData, props.afterRowAction]
    );

    const renderButtonsCell = useCallback(
        (cell) => {
            var value = cell.value;
            var row = cell.row;
            var rowData = cell.row.data;

            if (gridRowActions instanceof Array === false || gridRowActions.length <= 0) return <div />;

            var actions =
                gridRowActions instanceof Array
                    ? gridRowActions.filter(
                        (r) =>
                            r.code &&
                            cell.row.data.actions instanceof Array &&
                            cell.row.data.actions.some(
                                (a) => a.name === r.code && Boolean(a.visible)
                                //    && ['actionDelete', 'actionCancel'].includes(r.code) == false
                            )
                    )
                    : [];

            actions = actions.map((a) => {
                let strText = a.name instanceof Array ? AntCondition.getValue(rowData, a.name) : a.name;
                let strIcon = a.icon;
                let stylingMode = a.stylingMode;
                let width = a.width;
                if (!a.name) {
                    if (['actionDelete', 'actionCancel'].includes(a.code)) {
                        stylingMode = 'text';
                        strIcon = 'trash';
                        strText = '';
                        width = 30;
                    }
                    if (['actionReject'].includes(a.code)) {
                        stylingMode = 'text';
                        strIcon = 'clear';
                        strText = '';
                        width = 30;
                    }
                    if (['actionPost', 'actionApprove', 'actionClose'].includes(a.code)) {
                        stylingMode = 'text';
                        strIcon = 'check';
                        strText = '';
                        width = 30;
                    }
                    if (['actionRelease'].includes(a.code)) {
                        stylingMode = 'text';
                        strIcon = 'parentfolder';
                        strText = '';
                        width = 30;
                    }
                }
                strText = AntLocalization.translateText(strText);
                return {
                    id: a.code,
                    text: strText,
                    icon: strIcon,
                    type: a.type,
                    stylingMode: strText ? stylingMode : 'text',
                    width: strText ? (width ? width : 60) + 5 : 30
                };
            });

            if (!actions || actions.length <= 0) return <div />;
            return (
                <Toolbar className="ant-grid-cell-buttons" id={tableName + '-' + rowData.id} key={tableName + '-' + rowData.id}>
                    {actions.map((item, i) => {
                        return (
                            <Item key={tableName + '-' + rowData.id + '-' + i}>
                                <AntProcessingButton
                                    actionId={item.id}
                                    type={item.type}
                                    stylingMode={item.stylingMode}
                                    icon={item.icon}
                                    data={rowData}
                                    text={AntLocalization.translateText(item.text)}
                                    width={item.width}
                                    onClick={onRowAction}
                                />
                            </Item>
                        );
                    })}
                </Toolbar>
            );
        },
        [gridRowActions, onRowAction, tableName]
    );

    const onDatasourceLoaded = useCallback(
        (dataRows) => {
            loading.current = false;
            loaded.current = true;

            beginUpdate();

            autoResetUI({
                bysPassUpdate: true,
                byPassTimer: true
            });

            if (props.onLoaded) props.onLoaded(dataRows);

            endUpdate();
        },
        [autoResetUI, beginUpdate, endUpdate, props.onLoaded]
    );

    const initDataSourceConfig = useCallback(() => {
        return {
            key: props.keyExpr,
            API: props.API,
            url: props.url,
            loadFunc: props.loadFunc,
            remotePaging: true,
            isScrolling: true,

            getSearchConditions: dsGetSearchConditions,
            // getParentSearchConditions: dsGetParentSearchConditions,
            getQueryFields: dsGetQueryFields,
            getSearchText: dsGetSearchText,
            getOrderBy: dsGetOrderBy,
            getOrderings: dsGetOrderings,
            getOrderType: dsGetOrderType,
            // isAllowQuery: isAllowQuery,
            onLoading: onDatasourceLoading,
            onLoaded: onDatasourceLoaded
            // onUpdated: onDataSourceEdited
        };
    }, [
        props.keyExpr,
        props.API,
        props.url,
        props.loadFunc,
        // props.updateMode,
        isRemotePaging,
        dsGetSearchConditions,
        dsGetParentSearchConditions,
        dsGetQueryFields,
        dsGetSearchText,
        dsGetOrderBy,
        dsGetOrderings,
        dsGetOrderType,
        // isAllowQuery,
        onDatasourceLoading,
        onDatasourceLoaded
        // onDataSourceEdited
    ]);

    useImperativeHandle(ref, () => ({
        forceReload: forceReload,
        refresh: refresh,
        getKeyField: getKeyField,
        forceRender: forceRender,
        getCachedData: getCachedData,
        cleanData: cleanData,
        isDataLoaded: isDataLoaded,
        isDataLoading: isDataLoading
    }));

    useEffect(() => {
        dataSource.current.reInit(initDataSourceConfig());
        forceReload();
    }, [initDataSourceConfig]);

    useEffect(() => {
        generateSearchConditions();
    }, [generateSearchConditions]); //, actionBar.current

    const onSearchText = useCallback(
        (text) => {
            setSearchText(text);
            if (props.onSearchText) props.onSearchText(text);
        },
        [props.onSearchText]
    );

    const onRefreshClick = useCallback(() => {
        forceReload();
        if (props.onRefreshClick) props.onRefreshClick();
    }, [props.onSearchText]);

    useEffect(() => {
        forceReload();
    }, [props.parentData]); //, actionBar.current

    useEffect(() => {
        const instance = grid.current?.instance;
        if (!instance || props.isForeground === false) return undefined;
        const root = instance.element?.();
        const element = root?.get ? root.get(0) : root;
        if (!element) return undefined;

        let frame;
        let lastWidth = element.getBoundingClientRect().width;
        const view = element.ownerDocument?.defaultView;
        const reconcile = () => {
            frame = undefined;
            instance.updateDimensions();
            reconcileGridHeaderLayout(instance);
        };
        reconcile();

        if (typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver((entries) => {
            const width = entries?.[0]?.contentRect?.width || 0;
            if (!(width > 0) || Math.abs(width - lastWidth) < 1) return;
            lastWidth = width;
            if (frame) view?.cancelAnimationFrame?.(frame);
            if (view?.requestAnimationFrame) frame = view.requestAnimationFrame(reconcile);
            else reconcile();
        });
        observer.observe(element);
        return () => {
            observer.disconnect();
            if (frame) view?.cancelAnimationFrame?.(frame);
        };
    }, [isRender, props.isForeground]);

    const customizeColumns = useCallback((columns) => {
        // console.log('ant-log-columns : ',columns);
    }, []);

    useEffect(() => {
        if (autoRefreshTimer.current) clearInterval(autoRefreshTimer.current);

        if (props.autoRefreshSeconds)
            autoRefreshTimer.current = setInterval(() => {
                if (isForeground.current) forceReload();
            }, props.autoRefreshSeconds * 1000);
        return () => {
            if (autoRefreshTimer.current) clearInterval(autoRefreshTimer.current);
        };
    }, []);

    const isCategoriesShouldVisible = useCallback(
        (cats) => {
            if (!cats) return false;

            let isVisible = AntCondition.isVisible({}, cats);
            if (!isVisible) return false;
            if (cats.visible === true) return true;

            if (searchConditions.current && cats.lookups) {
                if (cats.lookups.some((l) => Object.keys(searchConditions.current).includes(l.field))) return true;
            }

            let ar1 = [props.searchCategories1];
            let ar2 = [selectedCats1.filter((s) => s.value && s.value.length > 0)];
            let ar3 = [itemsCats1];

            let ar4 = [itemsCats1Loaded];

            let currentCatIndex = ar1.findIndex((a) => stringify(a) === stringify(cats));
            let currentCatTotals = ar3[currentCatIndex];
            let currentCatSelecteds = ar2[currentCatIndex];
            let currentCatLoaded = ar4[currentCatIndex];

            if (!currentCatLoaded) return true;

            let _selectedCategories = [selectedCats1]
                .flat()
                .map((s) => s.value)
                .flat();

            if (cats.visibleDependOthers) {
                let _totalCats = itemsCats1.length;

                if (_totalCats > currentCatTotals.length) {
                    if (cats.visibleDependOthers instanceof Array) {
                        if (cats.visibleDependOthersType !== 'OR')
                            isVisible = cats.visibleDependOthers.every((oName) => {
                                for (let i = 0; i < ar1.length; i++) {
                                    const otherCat = ar1[i];
                                    const otherCatSelecteds = ar2[i];
                                    const otherCatTotals = ar3[i];
                                    if (otherCat && stringify(otherCat) !== stringify(cats)) {
                                        if (
                                            otherCat &&
                                            otherCat.lookups &&
                                            otherCat.lookups.some((l) => l.name === oName) &&
                                            (otherCatTotals.length <= 0 || otherCatSelecteds.length > 0)
                                        )
                                            return true;
                                    }
                                }

                                return false;
                            });
                        else {
                            isVisible = cats.visibleDependOthers.some((oName) => {
                                for (let i = 0; i < ar1.length; i++) {
                                    const otherCat = ar1[i];
                                    const otherCatSelecteds = ar2[i];
                                    const otherCatTotals = ar3[i];
                                    if (otherCat && stringify(otherCat) !== stringify(cats)) {
                                        if (
                                            otherCat &&
                                            otherCat.lookups &&
                                            otherCat.lookups.some((l) => l.name === oName) &&
                                            otherCatSelecteds.length > 0
                                        )
                                            return true;
                                    }
                                }

                                return false;
                            });

                            if (!isVisible)
                                isVisible = cats.visibleDependOthers.every((oName) => {
                                    for (let i = 0; i < ar1.length; i++) {
                                        const otherCat = ar1[i];
                                        const otherCatSelecteds = ar2[i];
                                        const otherCatTotals = ar3[i];
                                        if (otherCat && stringify(otherCat) !== stringify(cats)) {
                                            if (
                                                otherCat &&
                                                otherCat.lookups &&
                                                otherCat.lookups.some((l) => l.name === oName) &&
                                                otherCatTotals.length > 0
                                            )
                                                return false;
                                        }
                                    }

                                    return true;
                                });
                        }
                    } else {
                        isVisible = _selectedCategories.length > 0;
                    }
                }
            } else {
                isVisible = currentCatTotals.length > 1 || currentCatSelecteds.length > 0;
            }

            return isVisible;
        },
        [props.searchCategories1, itemsCats1, selectedCats1]
    );

    const cats1Visible = isCategoriesShouldVisible(props.searchCategories1);

    const onLoadedDataCat1 = useCallback((e) => {
        setItemsCats1(e.allItems ? e.allItems : []);
        setItemsCats1Loaded(true);
    }, []);

    const onSelectionChangedCat1 = useCallback(
        (e) => {
            setItemsCats1(e.allItems);
            setSelectedCats1(e.selectedItems);
            forceReload();
        },
        [forceReload]
    );

    const allowQueryCat1 = useCallback(
        (e) => {
            if (props.searchCategories1.visibleDependOthers) return selectedCategories.length > 0;
            return true;
        },
        [selectedCategories]
    );

    return (
        <React.Fragment>
            <Box direction="col" width="100%" height="100%">
                <BoxItem baseSize={'auto'}>
                    {isRender && props.showSearchBar !== false && (
                        <AntCardViewSearchBar
                            ref={searchBar}
                            API={props.API}
                            shouldRender={isRender}
                            showSearchBox={props.showSearchBox}
                            onSearchText={onSearchText}
                            onRefreshClick={onRefreshClick}
                        />
                    )}

                    {isRender && props.searchCategories1 && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', marginTop: props.showSearchBar !== false ? '2px' : '10px' }}>
                            {props.searchCategories1 && (
                                <AntPOSCategories
                                    API={props.API}
                                    shouldRender={isRender}
                                    searchText={String(searchText)}
                                    searchConditions={searchConditions}
                                    searchCategories={props.searchCategories1}
                                    selectedItems={selectedCats1}
                                    onLoadedData={onLoadedDataCat1}
                                    onSelectionChanged={onSelectionChangedCat1}
                                    visible={cats1Visible}
                                    allowQuery={allowQueryCat1}
                                ></AntPOSCategories>
                            )}
                        </div>
                    )}
                </BoxItem>
                {isRender && (
                    // <div style={{ display: 'block', overflowY: 'auto' }}>

                    <BoxItem ratio={1}>
                        <DataGrid
                            ref={grid}
                            shouldRender={isRender}
                            // noDataText="Không có dữ liệu"
                            noDataText=""
                            className={'dx-card wide-card ant-grid'}
                            dataSource={dataSource.current ? dataSource.current.instance() : null}
                            remoteOperations={true}
                            // cacheEnabled={true}
                            // focusedRowEnabled={props.cellStyles instanceof Array === false && props.rowStyles instanceof Array === false}
                            focusedRowEnabled={false}
                            // onFocusedRowChanged={onFocusedRowChanged}
                            onOptionChanged={onOptionChanged}
                            onCellClick={onCellClick}
                            onRowDblClick={onRowDblClick}
                            // defaultFocusedRowIndex={0}
                            height={'100%'}
                            // height={props.height ? props.height : "50%"}
                            width={props.width !== undefined ? props.width : 'inherit'}
                            showEditorAlways={true}
                            allowColumnResizing={false}
                            columnAutoWidth={true}
                            columnResizingMode={'nextColumn'}
                            columnHidingEnabled={true}
                            customizeColumns={customizeColumns}
                            showColumnLines={false}
                            showRowLines={true}
                            showBorders={false}
                            hoverStateEnabled={props.cellStyles instanceof Array === false && props.rowStyles instanceof Array === false}
                            rowAlternationEnabled={true}
                            repaintChangesOnly={true}
                            focusStateEnabled={
                                props.cellStyles instanceof Array === false &&
                                    props.rowStyles instanceof Array === false &&
                                    props.focusStateEnabled !== undefined
                                    ? props.focusStateEnabled
                                    : false
                            }
                            keyboardNavigation={
                                props.keyboardNavigation !== undefined
                                    ? props.keyboardNavigation
                                    : {
                                        enterKeyAction: 'moveFocus',
                                        enterKeyDirection: 'row',
                                        enabled: true,
                                        editOnKeyPress: true
                                    }
                            }
                            loadPanel={{ enabled: false }}
                            // scrolling={{
                            //     showScrollbar: 'never'
                            // }}
                            selection={{
                                mode: 'none'
                            }}
                            columnChooser={{
                                emptyPanelText: '',
                                enabled: false,
                                mode: 'select',
                                title: 'Ẩn hiện cột'
                            }}
                            pager={{
                                visible: false
                            }}
                            sorting={{
                                mode: 'none'
                            }}
                            // editing={
                            //     props.allowEdit === true
                            //         ? {
                            //               mode: 'cell',
                            //               allowUpdating: true,
                            //               selectTextOnEditStart: true
                            //           }
                            //         : {}
                            // }
                            wordWrapEnabled={false}
                            columns={mainColumns}
                            onInitialized={onInitialized}
                            onContentReady={onContentReady}
                            onCellPrepared={props.cellStyles instanceof Array || props.rowStyles instanceof Array ? onCellPrepared : undefined}
                        >
                            <Scrolling
                                mode="infinite"
                                // showScrollbar={'never'}
                                preloadEnabled={true}
                                rowRenderingMode="virtual"
                            />
                            <Template name={'renderBoldCell'} render={renderBoldCell} />
                            <Template name={'renderCustomFormatCell'} render={renderCustomFormatCell} />
                            <Template name={'renderContentCell'} render={renderContentCell} />
                            {/* <Template name={'renderLinkCell'} render={renderLinkCell} /> */}
                            <Template name={'renderButtonsCell'} render={renderButtonsCell} />
                            <Template name={'renderCheckboxCell'} render={renderCheckboxCell} />
                            <Template name={'renderNoteCell'} render={renderNoteCell} />
                            <Template name={'renderAttachmentCell'} render={renderAttachmentCell} />
                            <Template name={'renderPriorityCell'} render={renderPriorityCell} />
                            {/* <Template name={'renderDetailCell'} render={renderDetailCell} /> */}
                            {/* <Template name={'renderCellEditor'} render={renderCellEditor} /> */}
                        </DataGrid>
                    </BoxItem>
                    // </div>
                )}
            </Box>
        </React.Fragment>
    );
});
